// Multi-language dictionary.
// Keys are the original Simplified-Chinese source strings.
// Base language 'zh' returns the key as-is (no entries needed).
// Add a language by filling in its map below.

export const LANGS = [
  { code: 'zh', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en', label: 'English' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
];

export const translations = {
  en: {
    // ---- App chrome (nav / header / footer) ----
    '首页': 'Home',
    '主播同款改枪码': 'Streamer Builds',
    '官方热门改枪码': 'Official Hot Codes',
    '玩家社区': 'Community',
    '每日密码': 'Daily Codes',
    '特勤处制造利润': 'Crafting Profit',
    '价格走势图': 'Price Trends',
    '物品图鉴': 'Item Database',
    '卡战备系统': 'Loadout Cards',
    '官方地图工具': 'Tactical Map',
    '管理后台': 'Admin',
    '有力气的改枪': 'Gun Builds',
    '有力气的改枪网站': 'Delta Force Gun Codes',
    '三角洲行动改枪码大全': 'Delta Force Build Codes Hub',
    '隐私政策': 'Privacy Policy',
    '使用条款': 'Terms of Use',
    'Cookie 政策': 'Cookie Policy',
    // ---- Landing ----
    '改枪码已复制！': 'Build code copied!',
    '加载中...': 'Loading...',
    '有力气的改枪网站 - 三角洲行动(Delta Force)最全工具站：官方热门改枪码、主播同款改枪码、玩家社区分享、每日密码查询、特勤处制造利润计算、物品价格走势图、卡战备推荐系统。': 'Delta Force Gun Codes - the all-in-one toolkit: official hot build codes, streamer builds, community sharing, daily codes, crafting profit calculator, item price trends, and loadout recommendations.',
    '改枪码 · 每日密码 · 制造利润 · 价格走势 · 卡战备': 'Build Codes · Daily Codes · Crafting Profit · Price Trends · Loadouts',
    '官方改枪码': 'Official Codes',
    '官方主播': 'Streamers',
    '自定义枪械': 'Custom Guns',
    '改枪配置': 'Builds',
    '主播改枪码': 'Streamer Codes',
    '官方热门': 'Official Hot',
    '制造利润': 'Crafting Profit',
    '卡战备': 'Loadouts',
    '价格走势': 'Price Trends',
    '今日密码': "Today's Codes",
    '查看全部': 'View all',
    '今日最赚': 'Top Profit Today',
    '热门主播': 'Top Streamers',
    '{n}方案': '{n} builds',
    '{n}使用': '{n} uses',
    '热门改枪码': 'Hot Build Codes',
    // ---- MapTool ----
    '三角洲行动官方互动地图，查看物资点、出生点、撤离点、首领坐标等关键信息。': 'Delta Force official interactive map — loot spots, spawns, extraction points, and boss locations.',
    '三角洲行动官方互动地图 · 物资点 · 出生点 · 撤离点 · 首领坐标': 'Official interactive map · Loot · Spawns · Extractions · Bosses',
    '新窗口打开': 'Open in new window',
    '加载地图中...': 'Loading map...',
    '地图无法嵌入显示': 'The map cannot be embedded',
    '官方地图可能不支持嵌入，请点击下方按钮直接访问': 'The official map may not allow embedding. Please use the button below to open it directly.',
    '打开官方地图工具': 'Open the official map',
    '提示：': 'Tip: ',
    '地图数据来自腾讯官方。如果显示异常，点击右上角"新窗口打开"直接访问。': 'Map data is from Tencent. If it does not display correctly, use "Open in new window" at the top right.',
    // ---- DailyPassword ----
    '{name} 密码已复制！': '{name} code copied!',
    '加载每日密码中...': 'Loading daily codes...',
    '三角洲行动每日地图密码查询，零号大坝、长弓溪谷、巴克什、航天基地、潮汐监狱每日更新。': 'Delta Force daily map codes — updated daily for all maps.',
    '更新时间：': 'Updated: ',
    '暂无数据': 'No data',
    '（非今日数据）': "(not today's data)",
    '今日密码暂未更新': "Today's codes are not updated yet",
    '密码每天 00:00 自动更新，请稍后再来查看': 'Codes update automatically at 00:00 daily. Please check back later.',
    '已复制': 'Copied',
    '点击复制密码': 'Click to copy code',
    // map names
    '零号大坝': 'Zero Dam', '长弓溪谷': 'Longbow Valley', '巴克什': 'Brakkesh', '航天基地': 'Space City', '潮汐监狱': 'Tide Prison',
    // weapon / item categories
    '突击步枪': 'Assault Rifle', '战斗步枪': 'Battle Rifle', '射手步枪': 'Marksman Rifle', '冲锋枪': 'SMG', '机枪': 'LMG', '狙击步枪': 'Sniper Rifle', '连狙': 'Semi-auto Sniper', '霰弹枪': 'Shotgun', '手枪': 'Pistol', '弓弩': 'Bow', '子弹': 'Ammo', '医疗': 'Meds',
    '密码每天 00:00 自动更新。点击密码卡片可以快速复制。': 'Codes update automatically at 00:00 daily. Click a card to copy quickly.',
    // ---- ItemCatalog ----
    '传说': 'Legendary', '史诗': 'Epic', '稀有': 'Rare', '精良': 'Fine', '普通': 'Common', '简陋': 'Poor', '无': 'None',
    '物资道具': 'Supplies', '枪械': 'Guns', '配件': 'Attachments', '护甲': 'Armor', '装备': 'Gear', '近战': 'Melee',
    '全部': 'All',
    '{n}级': 'Tier {n}',
    '加载物品数据...': 'Loading items...',
    '返回物品列表': 'Back to item list',
    '产出地点：': 'Source: ',
    '重量：': 'Weight: ',
    '尺寸：': 'Size: ',
    '三角洲行动全物品图鉴百科，收录所有枪械、配件、护甲、装备的详细信息和价格。': 'Delta Force full item database — details and prices for every gun, attachment, armor, and piece of gear.',
    '三角洲行动所有物品信息 · {n} 个物品': 'All Delta Force item info · {n} items',
    '搜索物品名称、描述、产出地...': 'Search item name, description, source...',
    '全部品级': 'All tiers',
    '品级 高→低': 'Tier: High → Low',
    '价格 高→低': 'Price: High → Low',
    '价格 低→高': 'Price: Low → High',
    '名称排序': 'Sort by name',
    '找到 {n} 个物品': 'Found {n} items',
    '没有找到匹配的物品': 'No matching items found',
    // ---- Legal ----
    '法律声明': 'Legal Notice',
    '有力气的改枪网站的隐私政策、使用条款和Cookie政策。': 'Privacy Policy, Terms of Use and Cookie Policy of Delta Force Gun Codes.',
    '最后更新：2026年3月13日': 'Last updated: March 13, 2026',
    '欢迎访问有力气的改枪网站（以下简称"本站"，网址：guns.yufantechs.com）。本站由 YufanTechs 运营。我们非常重视您的隐私，本隐私政策旨在说明我们如何收集、使用和保护您的信息。': 'Welcome to Delta Force Gun Codes ("this site", at guns.yufantechs.com), operated by YufanTechs. We take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your information.',
    '1. 信息收集': '1. Information Collection',
    '1.1 您主动提供的信息': '1.1 Information you provide',
    '注册信息：当您在玩家社区注册账号时，我们会收集您的用户名和密码': 'Registration info: when you register in the community, we collect your username and password.',
    '发布内容：您发布的改枪码、评论等内容': 'Content you post: build codes, comments, and similar content.',
    '管理员信息：管理员登录所需的用户名和密码': 'Admin info: the username and password needed for admin login.',
    '1.2 自动收集的信息': '1.2 Automatically collected information',
    '访问日志：包括 IP 地址、浏览器类型、访问时间等基本信息（由 Netlify 托管平台自动记录）': 'Access logs: basic info such as IP address, browser type, and visit time (recorded automatically by the Netlify hosting platform).',
    '本站不使用任何第三方分析工具或广告追踪': 'This site does not use any third-party analytics tools or ad tracking.',
    '2. 信息使用': '2. Use of Information',
    '我们收集的信息仅用于以下目的：': 'The information we collect is used only for the following purposes:',
    '提供和改善本站服务': 'To provide and improve the site services.',
    '管理用户账号和权限': 'To manage user accounts and permissions.',
    '展示用户发布的改枪码内容': 'To display build-code content posted by users.',
    '维护网站安全和稳定运行': 'To maintain the security and stable operation of the site.',
    '3. 信息存储与安全': '3. Information Storage and Security',
    '数据存储在 Supabase（加拿大数据中心）提供的安全数据库中': 'Data is stored in a secure database provided by Supabase (Canada data center).',
    '密码以明文形式存储（注意：我们建议您不要使用与其他重要账号相同的密码）': 'Passwords are stored in plain text (note: we recommend not reusing passwords from other important accounts).',
    '我们采取合理的技术措施保护您的数据安全': 'We take reasonable technical measures to protect the security of your data.',
    '4. 信息共享': '4. Information Sharing',
    '我们不会将您的个人信息出售、出租或以其他方式分享给任何第三方，除非：': 'We will not sell, rent, or otherwise share your personal information with any third party, except:',
    '获得您的明确同意': 'With your explicit consent.',
    '法律法规要求': 'As required by laws and regulations.',
    '保护本站或其用户的合法权益': 'To protect the legitimate rights of this site or its users.',
    '5. 第三方服务': '5. Third-Party Services',
    '本站使用以下第三方服务：': 'This site uses the following third-party services:',
    'Supabase：数据库和后端服务': 'Supabase: database and backend services.',
    'Netlify：网站托管和部署': 'Netlify: website hosting and deployment.',
    '腾讯 AMS API：获取游戏相关数据（每日密码、物品价格等）': 'Tencent AMS API: retrieving game data (daily codes, item prices, etc.).',
    '6. 您的权利': '6. Your Rights',
    '您有权：': 'You have the right to:',
    '访问您的个人信息': 'Access your personal information.',
    '删除您的账号和相关数据': 'Delete your account and related data.',
    '撤回您发布的内容': 'Withdraw content you have posted.',
    '7. 未成年人保护': '7. Protection of Minors',
    '本站不针对 13 岁以下的儿童提供服务。如果您发现有未成年人在未经家长同意的情况下提供了个人信息，请联系我们。': 'This site is not intended for children under 13. If you find that a minor has provided personal information without parental consent, please contact us.',
    '8. 政策更新': '8. Policy Updates',
    '我们可能会不定期更新本隐私政策。更新后的政策将在本页面发布，建议您定期查看。': 'We may update this Privacy Policy from time to time. Updated policies will be posted on this page; please review it periodically.',
    '9. 联系我们': '9. Contact Us',
    '如果您对本隐私政策有任何疑问，请通过以下方式联系我们：': 'If you have any questions about this Privacy Policy, please contact us via:',
    '网站：guns.yufantechs.com': 'Website: guns.yufantechs.com',
    '请在使用本站服务之前仔细阅读以下条款。使用本站即表示您同意受这些条款的约束。': 'Please read the following terms carefully before using this site. By using this site, you agree to be bound by these terms.',
    '1. 服务说明': '1. Service Description',
    '有力气的改枪网站是一个面向《三角洲行动》（Delta Force）玩家的第三方工具网站，提供以下服务：': 'Delta Force Gun Codes is a third-party tool site for Delta Force players, offering the following services:',
    '改枪码分享与浏览': 'Sharing and browsing build codes.',
    '每日密码查询': 'Daily code lookup.',
    '特勤处制造利润计算': 'Crafting profit calculation.',
    '物品价格走势查询': 'Item price trend lookup.',
    '卡战备推荐系统': 'Loadout recommendation system.',
    '玩家社区功能': 'Player community features.',
    '2. 免责声明': '2. Disclaimer',
    '本站为非官方第三方工具，与腾讯、Team Jade 或三角洲行动官方无任何关联': 'This site is an unofficial third-party tool and is not affiliated with Tencent, Team Jade, or Delta Force officially.',
    '本站提供的数据来源于公开 API，仅供参考，不保证实时性和准确性': 'Data on this site comes from public APIs, is for reference only, and its timeliness and accuracy are not guaranteed.',
    '因游戏更新导致的数据偏差，本站不承担任何责任': 'This site is not responsible for data discrepancies caused by game updates.',
    '使用本站提供的改枪码或其他信息所产生的任何后果，由用户自行承担': 'Any consequences arising from using the build codes or other information provided by this site are borne by the user.',
    '3. 用户行为规范': '3. User Conduct',
    '使用本站服务时，您同意：': 'When using this site, you agree to:',
    '不发布违法、色情、暴力、仇恨或其他不当内容': 'Not post illegal, pornographic, violent, hateful, or otherwise inappropriate content.',
    '不冒充他人或虚假宣传': 'Not impersonate others or make false claims.',
    '不利用本站进行任何商业行为（未经授权）': 'Not use this site for any commercial activity without authorization.',
    '不尝试攻击、破坏或干扰本站的正常运行': 'Not attempt to attack, damage, or interfere with the normal operation of this site.',
    '不批量爬取或自动化访问本站数据': 'Not scrape in bulk or access the site data via automation.',
    '4. 知识产权': '4. Intellectual Property',
    '《三角洲行动》的商标、图像和游戏数据归腾讯及 Team Jade 所有': 'The trademarks, images, and game data of Delta Force belong to Tencent and Team Jade.',
    '本站的界面设计和代码归 YufanTechs 所有': 'The interface design and code of this site belong to YufanTechs.',
    '用户发布的改枪码内容归发布者所有': 'Build-code content posted by users belongs to the poster.',
    '5. 账号管理': '5. Account Management',
    '您有责任保护自己的账号安全': 'You are responsible for keeping your account secure.',
    '我们保留在违反使用条款时封禁或删除账号的权利': 'We reserve the right to ban or delete accounts that violate the Terms of Use.',
    '长期不活跃的账号可能会被清理': 'Long-inactive accounts may be cleaned up.',
    '6. 服务变更与终止': '6. Service Changes and Termination',
    '我们保留在任何时候修改、暂停或终止本站服务的权利，恕不另行通知。对于服务变更或终止造成的任何损失，本站不承担责任。': 'We reserve the right to modify, suspend, or terminate the site services at any time without notice. This site is not liable for any loss caused by such changes or termination.',
    '7. 条款修改': '7. Amendments to Terms',
    '我们可能会不定期修改本使用条款。修改后的条款将在本页面发布并立即生效。继续使用本站即表示您接受修改后的条款。': 'We may amend these Terms of Use from time to time. Amended terms will be posted on this page and take effect immediately. Continued use of this site means you accept the amended terms.',
    '1. 什么是 Cookie': '1. What is a Cookie',
    'Cookie 是网站存储在您浏览器中的小型文本文件，用于记录您的偏好和使用信息。': 'Cookies are small text files a website stores in your browser to record your preferences and usage information.',
    '2. 本站使用的存储方式': '2. Storage Methods We Use',
    '本站主要使用浏览器的 LocalStorage（本地存储）来保存以下信息：': 'This site mainly uses the browser LocalStorage to save the following information:',
    '玩家登录状态': 'Player login status',
    '：记住您的登录信息，避免每次访问都需要重新登录（存储键：df_player）': ': remembers your login so you do not need to log in on every visit (storage key: df_player).',
    '3. 本站不使用的技术': '3. Technologies We Do Not Use',
    '本站不使用第三方 Cookie': 'This site does not use third-party cookies.',
    '本站不使用广告追踪 Cookie': 'This site does not use ad-tracking cookies.',
    '本站不使用任何分析追踪工具（如 Google Analytics）': 'This site does not use any analytics tracking tools (such as Google Analytics).',
    '本站不进行跨站追踪': 'This site does not perform cross-site tracking.',
    '4. 第三方 Cookie': '4. Third-Party Cookies',
    '本站嵌入的官方地图工具（iframe）可能会设置来自 df.qq.com 的 Cookie，这些 Cookie 由腾讯控制，不在本站管理范围内。': 'The embedded official map tool (iframe) may set cookies from df.qq.com. These cookies are controlled by Tencent and are outside the scope of this site.',
    '5. 如何管理': '5. How to Manage',
    '您可以通过以下方式管理存储数据：': 'You can manage stored data in the following ways:',
    '在玩家社区页面点击"退出"清除登录数据': 'Click "Log out" on the community page to clear login data.',
    '在浏览器设置中清除本站的 LocalStorage 数据': 'Clear this site\'s LocalStorage data in your browser settings.',
    '使用浏览器的隐私/无痕模式访问本站': 'Visit this site using your browser\'s private/incognito mode.',
    '如果我们更改了数据存储方式，将更新本 Cookie 政策并在本页面发布。': 'If we change how we store data, we will update this Cookie Policy and post it on this page.',
    // ---- Loadout ----
    '加载战备数据中...': 'Loading loadouts...',
    '暂无战备数据': 'No loadout data yet',
    '头盔': 'Helmet', '胸挂': 'Rig', '背包': 'Backpack',
    '推荐配件': 'Recommended attachments',
    '购买成本': 'Buy cost', '装备价值': 'Gear value', '配件价值': 'Attachment value', '总估值': 'Total value',
    '三角洲行动卡战备配装推荐，不同预算档位的最优枪械、护甲、装备搭配方案。': 'Delta Force loadout recommendations — the best gun, armor, and gear combos for each budget tier.',
    '更新：': 'Updated: ',
    '价格基于交易行实时均价，每小时更新 · 含配件推荐': 'Prices based on live market average, updated hourly · includes attachment picks',
    '大坝、长弓机密': 'Dam & Valley · Classified',
    '巴克什、航天机密': 'Brakkesh & Spaceport · Classified',
    '潮汐监狱-适应': 'Tide Prison · Adapt',
    '巴克什-绝密': 'Brakkesh · Top Secret',
    '航天基地-绝密': 'Spaceport · Top Secret',
    '潮汐监狱-绝密': 'Tide Prison · Top Secret',
    '策略方案': 'Strategy builds', '多枪方案': 'Multi-gun builds',
    '该档位暂无{type}方案': 'No {type} builds for this tier',
    '策略': 'strategy', '多枪': 'multi-gun',
    '说明：': 'Notes: ',
    '：🔫枪械拉满 / ⚖️均衡 / 🦺胸挂拉满 / 🏃轻装跑图（少配件轻装，适合跑图丢包场景）。': ': 🔫 gun-focused / ⚖️ balanced / 🦺 rig-focused / 🏃 light run (few attachments, ideal for run-and-loot runs).',
    '：不同枪械+最优装备组合。': ': different guns paired with the best gear.',
    '配件': 'Attachments',
    '：点击展开查看推荐配件，价值已计入总估值。': ': click to expand recommended attachments; their value is included in the total.',
    '品级：': 'Tier: ',
    // ---- Streamers ----
    '加载主播数据...': 'Loading streamers...',
    '返回主播列表': 'Back to streamer list',
    '{n} 个方案 · {apply} 使用 · 点击展开查看配件': '{n} builds · {apply} uses · tap to view attachments',
    '搜索枪名或方案名...': 'Search gun or build name...',
    '{n} 赞': '{n} likes',
    '配件详情': 'Attachment details',
    '配件总价：': 'Attachments total: ',
    '无配件数据': 'No attachment data',
    '复制改枪码': 'Copy build code',
    '三角洲行动主播改枪码合集，热门主播同款武器配置方案，一键复制使用。': 'Delta Force streamer build codes — weapon setups from popular streamers, copy with one tap.',
    '来自官方社区 · {n} 位主播 · {c} 个方案': 'From the official community · {n} streamers · {c} builds',
    '搜索主播名称...': 'Search streamer name...',
    '没有找到「{q}」相关的主播': 'No streamers found for "{q}"',
    '{n} 个方案': '{n} builds',
    '{n} 使用': '{n} uses',
    // ---- Gun landing pages ----
    '武器改枪码大全': 'Gun Build Codes Hub',
    '武器改枪码': 'Gun Build Codes',
    '三角洲行动武器改枪码': 'Delta Force gun build codes',
    '三角洲行动各热门武器的改枪码大全，按武器查询官方与主播同款改枪码，一键复制。': 'Delta Force build codes for every popular weapon — look up official and streamer build codes by gun and copy in one tap.',
    '按武器查询三角洲行动改枪码 · 共 {n} 把武器': 'Browse Delta Force build codes by weapon · {n} guns',
    '「{model}」改枪码大全': '{model} Build Codes',
    '「{model}」改枪码': '{model} Build Codes',
    '「{model}」三角洲改枪码大全，收录该武器的官方与主播同款改枪码，一键复制导入游戏。': 'All {model} Delta Force build codes — official and streamer setups for this weapon, copy and import in one tap.',
    // ---- OfficialCodes ----
    '加载官方改枪码...': 'Loading official codes...',
    '三角洲行动官方社区热门改枪码，按使用量排行，含完整配件列表和价格。': 'Delta Force official community hot build codes, ranked by usage, with full attachment lists and prices.',
    '来自官方社区 · {c} 个方案 · 点击展开查看配件 · 同步：{time}': 'From the official community · {c} builds · tap to view attachments · synced: {time}',
    '搜索枪名、方案名、作者...': 'Search gun, build, or author...',
    '使用量 高→低': 'Usage: High → Low',
    '点赞 高→低': 'Likes: High → Low',
    '配件列表': 'Attachment list',
    '此方案无配件数据': 'No attachment data for this build',
    '点击卡片展开查看配件详情。点击改枪码直接复制。数据每6小时自动同步。': 'Tap a card to view attachment details. Tap a code to copy it. Data syncs automatically every 6 hours.',
    // ---- PriceTrend ----
    '需要至少2天数据才能显示走势图': 'At least 2 days of data are needed to show a trend chart',
    '系统每天自动记录价格，过几天就有图了': 'The system records prices daily — a chart will appear in a few days',
    '加载价格数据中...': 'Loading price data...',
    '三角洲行动物品价格走势图，实时追踪枪械、护甲、配件等物品的历史价格变化。': 'Delta Force item price trends — track historical price changes of guns, armor, attachments, and more.',
    '更新日期：': 'Updated: ',
    '共 {n} 个物品': '{n} items total',
    '搜索物品名称...': 'Search item name...',
    '暂无价格数据': 'No price data yet',
    '请管理员在后台获取价格数据': 'An admin needs to fetch price data from the backend',
    '价格为交易行均价，每天自动更新。点击物品可查看历史走势图。涨跌幅对比前一天数据。数据积累越多，走势图越完整。': 'Prices are the market average, updated daily. Click an item to see its historical chart. Change is compared to the previous day. The more data accumulates, the more complete the chart.',
    // ---- Manufacturing ----
    '加载制造数据中...': 'Loading crafting data...',
    '暂无制造数据': 'No crafting data yet',
    '请管理员在后台获取数据': 'An admin needs to fetch data from the backend',
    '三角洲行动特勤处制造利润计算器，实时制造成本与收益分析，找到最赚钱的制造方案。': 'Delta Force crafting profit calculator — real-time cost and profit analysis to find the most profitable recipes.',
    '共 {n} 个制造方案': '{n} recipes total',
    '各部门最赚推荐': 'Top pick per station',
    '技术中心': 'Tech Center', '工作台': 'Workbench', '制药台': 'Pharmacy', '防具台': 'Armor Bench',
    '净利润': 'Net profit',
    '每小时 {a} · 售价 {b}': '{a}/hr · sells for {b}',
    '总利润 高→低': 'Total profit: High → Low',
    '利润/小时 高→低': 'Profit/hr: High → Low',
    '售价 高→低': 'Sell price: High → Low',
    '耗时 短→长': 'Time: Short → Long',
    '售价': 'Sell', '成本': 'Cost', '每小时': 'Per hour', '总利润': 'Total profit',
    '总利润 = 售价 - 材料成本 - 手续费。品级颜色：': 'Total profit = sell price − material cost − fee. Tier colors:',
    // ---- Community ----
    '包含违规内容「{w}」': 'contains banned content "{w}"',
    '不允许包含手机号': 'may not contain a phone number',
    '不允许包含邮箱地址': 'may not contain an email address',
    '不允许包含网址链接': 'may not contain a URL',
    '不允许包含联系方式': 'may not contain contact info',
    '用户名{msg}': 'Username {msg}',
    '昵称{msg}': 'Nickname {msg}',
    '简介{msg}': 'Bio {msg}',
    '请先同意用户协议': 'Please agree to the user agreement first',
    '用户名和密码必填': 'Username and password are required',
    '密码至少6位': 'Password must be at least 6 characters',
    '两次密码不一致': 'Passwords do not match',
    '用户名已存在': 'Username already exists',
    '注册失败': 'Registration failed',
    '注册成功！': 'Registered successfully!',
    '欢迎，{name}！': 'Welcome, {name}!',
    '用户名或密码错误': 'Incorrect username or password',
    '登录尝试过多，请 {n} 分钟后再试': 'Too many login attempts. Try again in {n} minutes.',
    '已退出': 'Logged out',
    '头像上传失败': 'Avatar upload failed',
    '上传失败': 'Upload failed',
    '提交失败': 'Submission failed',
    '资料已提交，等待管理员审核': 'Submitted; awaiting admin review',
    '已有此枪械': 'This gun already exists',
    '{name} 已添加！': '{name} added!',
    '删除 {name}？其下所有改装码也会被删除！': 'Delete {name}? All its build codes will be deleted too!',
    '已删除': 'Deleted',
    '请填写改枪码': 'Please enter a build code',
    '已提交，等待管理员审核': 'Submitted; awaiting admin review',
    '确定删除？': 'Delete for sure?',
    '更新成功！': 'Updated successfully!',
    '加载社区数据...': 'Loading community...',
    '加载枪械数据中...': 'Loading gun data...',
    '返回社区': 'Back to community',
    '{name} 的改枪码': "{name}'s build codes",
    '点击改枪码即可复制 · {g} 把武器 · {v} 个配置': 'Click a code to copy · {g} guns · {v} builds',
    '添加枪械与改枪码': 'Add guns and build codes',
    '搜索枪械（从官方目录添加）': 'Search guns (add from official catalog)',
    '输入枪名，如 AKM、M4A1...': 'Enter a gun name, e.g. AKM, M4A1...',
    '添加': 'Add',
    '选择枪械添加改枪码': 'Select a gun to add a build code',
    '-- 选择枪械 --': '-- Select a gun --',
    '({n}个配置)': '({n} builds)',
    '段位': 'Tier',
    '不选': 'None',
    '价格': 'Price',
    '类型': 'Type',
    '满改': 'Full mod',
    '52米': '52m',
    '射程': 'Range',
    '改枪码 *': 'Build code *',
    '粘贴改枪码': 'Paste build code',
    '添加改枪码': 'Add build code',
    '全部段位': 'All tiers',
    '默认排序': 'Default order',
    '还没有枪械，使用上方搜索框添加': 'No guns yet — use the search box above to add one',
    '没有找到匹配的枪械': 'No matching guns found',
    '{n} 个配置方案': '{n} builds',
    '删除枪械': 'Delete gun',
    '改装类型': 'Mod type',
    '改枪码': 'Build code',
    '有效射程': 'Effective range',
    '操作': 'Actions',
    '存': 'Save', '消': 'Cancel', '编': 'Edit', '删': 'Del',
    '待审核': 'Pending',
    '三角洲行动玩家改枪码分享社区，注册分享你的武器配置方案，交流改枪心得。': 'Delta Force player build-code sharing community — register to share your weapon builds and swap tips.',
    '退出': 'Log out',
    '登录': 'Log in',
    '注册': 'Sign up',
    '分享和发现玩家的改枪方案 · 点击作者查看改枪码': 'Share and discover player builds · click an author to view their codes',
    '搜索玩家...': 'Search players...',
    '我的改枪码': 'My build codes',
    '还没有人分享改枪码': 'No one has shared build codes yet',
    '点击上方按钮开始添加！': 'Click the button above to start adding!',
    '登录后即可创建改枪方案': 'Log in to create your builds',
    '我': 'Me',
    '{n} 把武器': '{n} guns',
    '{n} 个配置': '{n} builds',
    '用户名': 'Username',
    '密码': 'Password',
    '（至少6位）': ' (at least 6 characters)',
    '确认密码': 'Confirm password',
    '再次输入密码': 'Re-enter password',
    '密码一致': 'Passwords match',
    '昵称（选填）': 'Nickname (optional)',
    '昵称': 'Nickname',
    '我已阅读并同意': 'I have read and agree to the',
    '《用户协议》': 'Terms of Service',
    '和': 'and',
    '《隐私政策》': 'Privacy Policy',
    '个人资料': 'Profile',
    '你有一份资料修改正在审核中，审核通过后自动生效': 'You have a profile change under review; it will take effect once approved',
    '显示名称': 'Display name',
    '个人简介': 'Bio',
    '一句话介绍自己': 'Introduce yourself in one line',
    '保存中...': 'Saving...',
    '保存': 'Save',
    '取消': 'Cancel',
  },
  ja: {
    '首页': 'ホーム',
    '主播同款改枪码': '配信者の改造コード',
    '官方热门改枪码': '公式人気コード',
    '玩家社区': 'コミュニティ',
    '每日密码': '毎日のコード',
    '特勤处制造利润': '製造利益',
    '价格走势图': '価格推移',
    '物品图鉴': 'アイテム図鑑',
    '卡战备系统': '装備カード',
    '官方地图工具': 'マップツール',
    '管理后台': '管理画面',
    '有力气的改枪': 'ガン改造',
    '有力气的改枪网站': 'デルタフォース 改造コード',
    '三角洲行动改枪码大全': 'デルタフォース 改造コード大全',
    '隐私政策': 'プライバシーポリシー',
    '使用条款': '利用規約',
    'Cookie 政策': 'Cookieポリシー',
    // ---- Landing ----
    '改枪码已复制！': '改造コードをコピーしました！',
    '加载中...': '読み込み中...',
    '有力气的改枪网站 - 三角洲行动(Delta Force)最全工具站：官方热门改枪码、主播同款改枪码、玩家社区分享、每日密码查询、特勤处制造利润计算、物品价格走势图、卡战备推荐系统。': 'デルタフォース改造コード - オールインワンツール：公式人気コード、配信者の改造コード、コミュニティ共有、毎日のコード、製造利益計算、価格推移、装備おすすめ。',
    '改枪码 · 每日密码 · 制造利润 · 价格走势 · 卡战备': '改造コード · 毎日のコード · 製造利益 · 価格推移 · 装備',
    '官方改枪码': '公式コード',
    '官方主播': '配信者',
    '自定义枪械': 'カスタム銃',
    '改枪配置': '構成',
    '主播改枪码': '配信者コード',
    '官方热门': '公式人気',
    '制造利润': '製造利益',
    '卡战备': '装備',
    '价格走势': '価格推移',
    '今日密码': '今日のコード',
    '查看全部': 'すべて見る',
    '今日最赚': '本日の高利益',
    '热门主播': '人気配信者',
    '{n}方案': '{n}件の構成',
    '{n}使用': '{n}回使用',
    '热门改枪码': '人気の改造コード',
    // ---- MapTool ----
    '三角洲行动官方互动地图，查看物资点、出生点、撤离点、首领坐标等关键信息。': 'デルタフォース公式インタラクティブマップ。物資・出現地点・脱出地点・ボス座標を確認。',
    '三角洲行动官方互动地图 · 物资点 · 出生点 · 撤离点 · 首领坐标': '公式インタラクティブマップ · 物資 · 出現地点 · 脱出地点 · ボス',
    '新窗口打开': '新しいウィンドウで開く',
    '加载地图中...': 'マップを読み込み中...',
    '地图无法嵌入显示': 'マップを埋め込み表示できません',
    '官方地图可能不支持嵌入，请点击下方按钮直接访问': '公式マップは埋め込みに対応していない場合があります。下のボタンから直接アクセスしてください。',
    '打开官方地图工具': '公式マップを開く',
    '提示：': 'ヒント：',
    '地图数据来自腾讯官方。如果显示异常，点击右上角"新窗口打开"直接访问。': 'マップデータはTencent公式提供です。表示がおかしい場合は右上の「新しいウィンドウで開く」からアクセスしてください。',
    // ---- DailyPassword ----
    '{name} 密码已复制！': '{name} のコードをコピーしました！',
    '加载每日密码中...': '毎日のコードを読み込み中...',
    '三角洲行动每日地图密码查询，零号大坝、长弓溪谷、巴克什、航天基地、潮汐监狱每日更新。': 'デルタフォース毎日のマップコード。全マップ毎日更新。',
    '更新时间：': '更新時刻：',
    '暂无数据': 'データなし',
    '（非今日数据）': '（本日のデータではありません）',
    '今日密码暂未更新': '本日のコードはまだ更新されていません',
    '密码每天 00:00 自动更新，请稍后再来查看': 'コードは毎日00:00に自動更新されます。後ほどご確認ください。',
    '已复制': 'コピー済み',
    '点击复制密码': 'クリックしてコードをコピー',
    // map names
    '零号大坝': 'ゼロダム', '长弓溪谷': 'ロングボウ渓谷', '巴克什': 'バクシュ', '航天基地': 'スペースシティ', '潮汐监狱': '潮汐監獄',
    // weapon / item categories
    '突击步枪': 'アサルトライフル', '战斗步枪': 'バトルライフル', '射手步枪': 'マークスマンライフル', '冲锋枪': 'サブマシンガン', '机枪': 'マシンガン', '狙击步枪': 'スナイパーライフル', '连狙': '連射スナイパー', '霰弹枪': 'ショットガン', '手枪': 'ピストル', '弓弩': '弓・クロスボウ', '子弹': '弾薬', '医疗': '医療',
    '密码每天 00:00 自动更新。点击密码卡片可以快速复制。': 'コードは毎日00:00に自動更新されます。カードをクリックで簡単にコピーできます。',
    // ---- ItemCatalog ----
    '传说': 'レジェンド', '史诗': 'エピック', '稀有': 'レア', '精良': '上級', '普通': 'ノーマル', '简陋': '粗悪', '无': 'なし',
    '物资道具': '物資', '枪械': '銃器', '配件': 'アタッチメント', '护甲': 'アーマー', '装备': '装備', '近战': '近接',
    '全部': 'すべて',
    '{n}级': 'Tier {n}',
    '加载物品数据...': 'アイテムを読み込み中...',
    '返回物品列表': 'アイテム一覧に戻る',
    '产出地点：': '入手場所：',
    '重量：': '重量：',
    '尺寸：': 'サイズ：',
    '三角洲行动全物品图鉴百科，收录所有枪械、配件、护甲、装备的详细信息和价格。': 'デルタフォース全アイテム図鑑。銃器・アタッチメント・アーマー・装備の詳細と価格を掲載。',
    '三角洲行动所有物品信息 · {n} 个物品': '全アイテム情報 · {n}件',
    '搜索物品名称、描述、产出地...': 'アイテム名・説明・入手場所で検索...',
    '全部品级': '全品級',
    '品级 高→低': '品級 高→低',
    '价格 高→低': '価格 高→低',
    '价格 低→高': '価格 低→高',
    '名称排序': '名前順',
    '找到 {n} 个物品': '{n}件見つかりました',
    '没有找到匹配的物品': '一致するアイテムがありません',
    // ---- Legal ----
    '法律声明': '法的通知',
    '有力气的改枪网站的隐私政策、使用条款和Cookie政策。': 'デルタフォース改造コードのプライバシーポリシー・利用規約・Cookieポリシー。',
    '最后更新：2026年3月13日': '最終更新：2026年3月13日',
    '欢迎访问有力气的改枪网站（以下简称"本站"，网址：guns.yufantechs.com）。本站由 YufanTechs 运营。我们非常重视您的隐私，本隐私政策旨在说明我们如何收集、使用和保护您的信息。': 'デルタフォース改造コード（以下「当サイト」、guns.yufantechs.com）へようこそ。当サイトはYufanTechsが運営しています。私たちはお客様のプライバシーを重視しており、本ポリシーでは情報の収集・利用・保護方法を説明します。',
    '1. 信息收集': '1. 情報の収集',
    '1.1 您主动提供的信息': '1.1 お客様が提供する情報',
    '注册信息：当您在玩家社区注册账号时，我们会收集您的用户名和密码': '登録情報：コミュニティで登録する際、ユーザー名とパスワードを収集します。',
    '发布内容：您发布的改枪码、评论等内容': '投稿内容：投稿された改造コード、コメントなど。',
    '管理员信息：管理员登录所需的用户名和密码': '管理者情報：管理者ログインに必要なユーザー名とパスワード。',
    '1.2 自动收集的信息': '1.2 自動的に収集する情報',
    '访问日志：包括 IP 地址、浏览器类型、访问时间等基本信息（由 Netlify 托管平台自动记录）': 'アクセスログ：IPアドレス、ブラウザ種別、アクセス時刻などの基本情報（Netlifyホスティングにより自動記録）。',
    '本站不使用任何第三方分析工具或广告追踪': '当サイトはサードパーティの分析ツールや広告トラッキングを一切使用しません。',
    '2. 信息使用': '2. 情報の利用',
    '我们收集的信息仅用于以下目的：': '収集した情報は以下の目的にのみ使用します：',
    '提供和改善本站服务': 'サービスの提供および改善のため。',
    '管理用户账号和权限': 'ユーザーアカウントと権限の管理のため。',
    '展示用户发布的改枪码内容': 'ユーザー投稿の改造コードを表示するため。',
    '维护网站安全和稳定运行': 'サイトの安全と安定運用の維持のため。',
    '3. 信息存储与安全': '3. 情報の保管とセキュリティ',
    '数据存储在 Supabase（加拿大数据中心）提供的安全数据库中': 'データはSupabase（カナダのデータセンター）が提供する安全なデータベースに保管されます。',
    '密码以明文形式存储（注意：我们建议您不要使用与其他重要账号相同的密码）': 'パスワードは平文で保管されます（注意：他の重要なアカウントと同じパスワードの使用は避けることを推奨します）。',
    '我们采取合理的技术措施保护您的数据安全': '合理的な技術的措置を講じてデータの安全を保護します。',
    '4. 信息共享': '4. 情報の共有',
    '我们不会将您的个人信息出售、出租或以其他方式分享给任何第三方，除非：': '以下の場合を除き、お客様の個人情報を第三者に販売・貸与・共有しません：',
    '获得您的明确同意': 'お客様の明示的な同意がある場合。',
    '法律法规要求': '法令で要求される場合。',
    '保护本站或其用户的合法权益': '当サイトまたは利用者の正当な権利を保護する場合。',
    '5. 第三方服务': '5. サードパーティサービス',
    '本站使用以下第三方服务：': '当サイトは以下のサードパーティサービスを利用します：',
    'Supabase：数据库和后端服务': 'Supabase：データベースおよびバックエンドサービス。',
    'Netlify：网站托管和部署': 'Netlify：ウェブサイトのホスティングとデプロイ。',
    '腾讯 AMS API：获取游戏相关数据（每日密码、物品价格等）': 'Tencent AMS API：ゲーム関連データ（毎日のコード、アイテム価格など）の取得。',
    '6. 您的权利': '6. お客様の権利',
    '您有权：': 'お客様には以下の権利があります：',
    '访问您的个人信息': '個人情報にアクセスする。',
    '删除您的账号和相关数据': 'アカウントおよび関連データを削除する。',
    '撤回您发布的内容': '投稿した内容を取り下げる。',
    '7. 未成年人保护': '7. 未成年者の保護',
    '本站不针对 13 岁以下的儿童提供服务。如果您发现有未成年人在未经家长同意的情况下提供了个人信息，请联系我们。': '当サイトは13歳未満の児童を対象としていません。保護者の同意なく未成年者が個人情報を提供していることに気付いた場合はご連絡ください。',
    '8. 政策更新': '8. ポリシーの更新',
    '我们可能会不定期更新本隐私政策。更新后的政策将在本页面发布，建议您定期查看。': '本ポリシーは随時更新される場合があります。更新後のポリシーは本ページに掲載しますので、定期的にご確認ください。',
    '9. 联系我们': '9. お問い合わせ',
    '如果您对本隐私政策有任何疑问，请通过以下方式联系我们：': '本ポリシーについてご質問がある場合は、以下からお問い合わせください：',
    '网站：guns.yufantechs.com': 'ウェブサイト：guns.yufantechs.com',
    '请在使用本站服务之前仔细阅读以下条款。使用本站即表示您同意受这些条款的约束。': '当サイトを利用する前に以下の規約をよくお読みください。利用をもって本規約に同意したものとみなされます。',
    '1. 服务说明': '1. サービス内容',
    '有力气的改枪网站是一个面向《三角洲行动》（Delta Force）玩家的第三方工具网站，提供以下服务：': 'デルタフォース改造コードは『Delta Force』プレイヤー向けのサードパーティツールサイトで、以下のサービスを提供します：',
    '改枪码分享与浏览': '改造コードの共有と閲覧。',
    '每日密码查询': '毎日のコード検索。',
    '特勤处制造利润计算': '製造利益の計算。',
    '物品价格走势查询': 'アイテム価格推移の検索。',
    '卡战备推荐系统': '装備おすすめシステム。',
    '玩家社区功能': 'コミュニティ機能。',
    '2. 免责声明': '2. 免責事項',
    '本站为非官方第三方工具，与腾讯、Team Jade 或三角洲行动官方无任何关联': '当サイトは非公式のサードパーティツールであり、Tencent、Team Jade、Delta Force公式とは一切関係ありません。',
    '本站提供的数据来源于公开 API，仅供参考，不保证实时性和准确性': '当サイトのデータは公開APIに基づく参考情報であり、即時性・正確性を保証しません。',
    '因游戏更新导致的数据偏差，本站不承担任何责任': 'ゲーム更新によるデータのずれについて、当サイトは責任を負いません。',
    '使用本站提供的改枪码或其他信息所产生的任何后果，由用户自行承担': '当サイトの改造コード等の情報の利用により生じた結果は、利用者自身が負担します。',
    '3. 用户行为规范': '3. 利用者の行動規範',
    '使用本站服务时，您同意：': '当サイトを利用する際、以下に同意するものとします：',
    '不发布违法、色情、暴力、仇恨或其他不当内容': '違法・わいせつ・暴力・憎悪その他不適切なコンテンツを投稿しないこと。',
    '不冒充他人或虚假宣传': '他人へのなりすましや虚偽の宣伝をしないこと。',
    '不利用本站进行任何商业行为（未经授权）': '無断で当サイトを商業目的に利用しないこと。',
    '不尝试攻击、破坏或干扰本站的正常运行': '当サイトの正常な運用を攻撃・破壊・妨害しようとしないこと。',
    '不批量爬取或自动化访问本站数据': '当サイトのデータを大量にスクレイピング、または自動化アクセスしないこと。',
    '4. 知识产权': '4. 知的財産権',
    '《三角洲行动》的商标、图像和游戏数据归腾讯及 Team Jade 所有': '『Delta Force』の商標・画像・ゲームデータはTencentおよびTeam Jadeに帰属します。',
    '本站的界面设计和代码归 YufanTechs 所有': '当サイトのUIデザインおよびコードはYufanTechsに帰属します。',
    '用户发布的改枪码内容归发布者所有': 'ユーザー投稿の改造コードは投稿者に帰属します。',
    '5. 账号管理': '5. アカウント管理',
    '您有责任保护自己的账号安全': 'ご自身のアカウントの安全を守る責任があります。',
    '我们保留在违反使用条款时封禁或删除账号的权利': '規約違反時にアカウントを凍結・削除する権利を留保します。',
    '长期不活跃的账号可能会被清理': '長期間非アクティブなアカウントは整理される場合があります。',
    '6. 服务变更与终止': '6. サービスの変更と終了',
    '我们保留在任何时候修改、暂停或终止本站服务的权利，恕不另行通知。对于服务变更或终止造成的任何损失，本站不承担责任。': '当サイトはいつでも予告なくサービスを変更・停止・終了する権利を留保します。これによる損失について当サイトは責任を負いません。',
    '7. 条款修改': '7. 規約の変更',
    '我们可能会不定期修改本使用条款。修改后的条款将在本页面发布并立即生效。继续使用本站即表示您接受修改后的条款。': '本規約は随時変更される場合があります。変更後の規約は本ページに掲載され、即時発効します。利用を継続することで変更後の規約に同意したものとみなされます。',
    '1. 什么是 Cookie': '1. Cookieとは',
    'Cookie 是网站存储在您浏览器中的小型文本文件，用于记录您的偏好和使用信息。': 'Cookieとは、ウェブサイトがブラウザに保存する小さなテキストファイルで、設定や利用情報を記録します。',
    '2. 本站使用的存储方式': '2. 当サイトの保存方式',
    '本站主要使用浏览器的 LocalStorage（本地存储）来保存以下信息：': '当サイトは主にブラウザのLocalStorageを利用して以下の情報を保存します：',
    '玩家登录状态': 'プレイヤーのログイン状態',
    '：记住您的登录信息，避免每次访问都需要重新登录（存储键：df_player）': '：ログイン情報を記憶し、毎回のログインを不要にします（保存キー：df_player）。',
    '3. 本站不使用的技术': '3. 当サイトが使用しない技術',
    '本站不使用第三方 Cookie': '当サイトはサードパーティCookieを使用しません。',
    '本站不使用广告追踪 Cookie': '当サイトは広告トラッキングCookieを使用しません。',
    '本站不使用任何分析追踪工具（如 Google Analytics）': '当サイトは分析トラッキングツール（Google Analyticsなど）を一切使用しません。',
    '本站不进行跨站追踪': '当サイトはクロスサイトトラッキングを行いません。',
    '4. 第三方 Cookie': '4. サードパーティCookie',
    '本站嵌入的官方地图工具（iframe）可能会设置来自 df.qq.com 的 Cookie，这些 Cookie 由腾讯控制，不在本站管理范围内。': '埋め込まれた公式マップツール（iframe）はdf.qq.comのCookieを設定する場合があります。これらはTencentが管理し、当サイトの管理範囲外です。',
    '5. 如何管理': '5. 管理方法',
    '您可以通过以下方式管理存储数据：': '以下の方法で保存データを管理できます：',
    '在玩家社区页面点击"退出"清除登录数据': 'コミュニティページで「ログアウト」をクリックしてログインデータを消去する。',
    '在浏览器设置中清除本站的 LocalStorage 数据': 'ブラウザ設定で当サイトのLocalStorageデータを消去する。',
    '使用浏览器的隐私/无痕模式访问本站': 'ブラウザのプライベート／シークレットモードで当サイトを利用する。',
    '如果我们更改了数据存储方式，将更新本 Cookie 政策并在本页面发布。': 'データ保存方式を変更した場合は、本Cookieポリシーを更新し本ページに掲載します。',
    // ---- Loadout ----
    '加载战备数据中...': '装備データを読み込み中...',
    '暂无战备数据': '装備データがありません',
    '头盔': 'ヘルメット', '胸挂': 'チェストリグ', '背包': 'バックパック',
    '推荐配件': 'おすすめアタッチメント',
    '购买成本': '購入コスト', '装备价值': '装備価値', '配件价值': 'アタッチメント価値', '总估值': '総評価額',
    '三角洲行动卡战备配装推荐，不同预算档位的最优枪械、护甲、装备搭配方案。': 'デルタフォース装備おすすめ。予算帯ごとの最適な銃・アーマー・装備の組み合わせ。',
    '更新：': '更新：',
    '价格基于交易行实时均价，每小时更新 · 含配件推荐': '価格は取引所のリアルタイム平均に基づき毎時更新 · アタッチメント推奨込み',
    '大坝、长弓机密': 'ダム・ロングボウ 機密',
    '巴克什、航天机密': 'バクシュ・宇宙基地 機密',
    '潮汐监狱-适应': '潮汐監獄・適応',
    '巴克什-绝密': 'バクシュ・極秘',
    '航天基地-绝密': '宇宙基地・極秘',
    '潮汐监狱-绝密': '潮汐監獄・極秘',
    '策略方案': '戦略構成', '多枪方案': 'マルチガン構成',
    '该档位暂无{type}方案': 'この帯の{type}構成はありません',
    '策略': '戦略', '多枪': 'マルチガン',
    '说明：': '説明：',
    '：🔫枪械拉满 / ⚖️均衡 / 🦺胸挂拉满 / 🏃轻装跑图（少配件轻装，适合跑图丢包场景）。': '：🔫火力重視 / ⚖️バランス / 🦺リグ重視 / 🏃軽装（アタッチメント少なめの軽装、周回・投げ荷向け）。',
    '：不同枪械+最优装备组合。': '：異なる銃＋最適装備の組み合わせ。',
    '配件': 'アタッチメント',
    '：点击展开查看推荐配件，价值已计入总估值。': '：クリックで推奨アタッチメントを表示。価値は総評価額に含まれます。',
    '品级：': '品級：',
    // ---- Streamers ----
    '加载主播数据...': '配信者データを読み込み中...',
    '返回主播列表': '配信者一覧に戻る',
    '{n} 个方案 · {apply} 使用 · 点击展开查看配件': '{n}件の構成 · {apply}回使用 · タップでアタッチメント表示',
    '搜索枪名或方案名...': '銃名または構成名で検索...',
    '{n} 赞': '{n}いいね',
    '配件详情': 'アタッチメント詳細',
    '配件总价：': 'アタッチメント合計：',
    '无配件数据': 'アタッチメントデータなし',
    '复制改枪码': '改造コードをコピー',
    '三角洲行动主播改枪码合集，热门主播同款武器配置方案，一键复制使用。': 'デルタフォース配信者の改造コード集。人気配信者の武器構成をワンタップでコピー。',
    '来自官方社区 · {n} 位主播 · {c} 个方案': '公式コミュニティより · 配信者{n}名 · 構成{c}件',
    '搜索主播名称...': '配信者名で検索...',
    '没有找到「{q}」相关的主播': '「{q}」に一致する配信者が見つかりません',
    '{n} 个方案': '{n}件の構成',
    '{n} 使用': '{n}回使用',
    // ---- Gun landing pages ----
    '武器改枪码大全': '武器別 改造コード',
    '武器改枪码': '武器改造コード',
    '三角洲行动武器改枪码': 'デルタフォース武器改造コード',
    '三角洲行动各热门武器的改枪码大全，按武器查询官方与主播同款改枪码，一键复制。': 'デルタフォースの人気武器ごとの改造コード。武器別に公式・配信者コードを検索してワンタップでコピー。',
    '按武器查询三角洲行动改枪码 · 共 {n} 把武器': '武器別にデルタフォース改造コードを検索 · 全{n}丁',
    '「{model}」改枪码大全': '{model} の改造コード',
    '「{model}」改枪码': '{model} の改造コード',
    '「{model}」三角洲改枪码大全，收录该武器的官方与主播同款改枪码，一键复制导入游戏。': '{model} のデルタフォース改造コード集。この武器の公式・配信者コードを収録、ワンタップでコピー。',
    // ---- OfficialCodes ----
    '加载官方改枪码...': '公式コードを読み込み中...',
    '三角洲行动官方社区热门改枪码，按使用量排行，含完整配件列表和价格。': 'デルタフォース公式コミュニティの人気改造コード。使用数順、アタッチメント一覧と価格付き。',
    '来自官方社区 · {c} 个方案 · 点击展开查看配件 · 同步：{time}': '公式コミュニティより · 構成{c}件 · タップでアタッチメント表示 · 同期：{time}',
    '搜索枪名、方案名、作者...': '銃名・構成名・作者で検索...',
    '使用量 高→低': '使用数 高→低',
    '点赞 高→低': 'いいね 高→低',
    '配件列表': 'アタッチメント一覧',
    '此方案无配件数据': 'この構成にアタッチメントデータがありません',
    '点击卡片展开查看配件详情。点击改枪码直接复制。数据每6小时自动同步。': 'カードをタップでアタッチメント詳細を表示。コードをタップでコピー。データは6時間ごとに自動同期。',
    // ---- PriceTrend ----
    '需要至少2天数据才能显示走势图': '推移グラフの表示には最低2日分のデータが必要です',
    '系统每天自动记录价格，过几天就有图了': 'システムは毎日価格を記録します。数日でグラフが表示されます',
    '加载价格数据中...': '価格データを読み込み中...',
    '三角洲行动物品价格走势图，实时追踪枪械、护甲、配件等物品的历史价格变化。': 'デルタフォースのアイテム価格推移。銃・アーマー・アタッチメントなどの過去の価格変動を追跡。',
    '更新日期：': '更新日：',
    '共 {n} 个物品': '全{n}件',
    '搜索物品名称...': 'アイテム名で検索...',
    '暂无价格数据': '価格データがありません',
    '请管理员在后台获取价格数据': '管理者が管理画面で価格データを取得する必要があります',
    '价格为交易行均价，每天自动更新。点击物品可查看历史走势图。涨跌幅对比前一天数据。数据积累越多，走势图越完整。': '価格は取引所の平均値で毎日自動更新されます。アイテムをクリックで推移グラフを表示。増減は前日比です。データが増えるほどグラフは充実します。',
    // ---- Manufacturing ----
    '加载制造数据中...': '製造データを読み込み中...',
    '暂无制造数据': '製造データがありません',
    '请管理员在后台获取数据': '管理者が管理画面でデータを取得する必要があります',
    '三角洲行动特勤处制造利润计算器，实时制造成本与收益分析，找到最赚钱的制造方案。': 'デルタフォース製造利益計算機。製造コストと利益をリアルタイム分析し、最も稼げるレシピを発見。',
    '共 {n} 个制造方案': '全{n}レシピ',
    '各部门最赚推荐': '各施設のおすすめ',
    '技术中心': 'テックセンター', '工作台': 'ワークベンチ', '制药台': '製薬台', '防具台': '防具台',
    '净利润': '純利益',
    '每小时 {a} · 售价 {b}': '毎時 {a} · 売価 {b}',
    '总利润 高→低': '総利益 高→低',
    '利润/小时 高→低': '利益/時 高→低',
    '售价 高→低': '売価 高→低',
    '耗时 短→长': '所要時間 短→長',
    '售价': '売価', '成本': 'コスト', '每小时': '毎時', '总利润': '総利益',
    '总利润 = 售价 - 材料成本 - 手续费。品级颜色：': '総利益 = 売価 − 材料コスト − 手数料。品級カラー：',
    // ---- Community ----
    '包含违规内容「{w}」': 'に禁止された内容「{w}」が含まれています',
    '不允许包含手机号': 'に電話番号を含めることはできません',
    '不允许包含邮箱地址': 'にメールアドレスを含めることはできません',
    '不允许包含网址链接': 'にURLを含めることはできません',
    '不允许包含联系方式': 'に連絡先を含めることはできません',
    '用户名{msg}': 'ユーザー名{msg}',
    '昵称{msg}': 'ニックネーム{msg}',
    '简介{msg}': '自己紹介{msg}',
    '请先同意用户协议': '先に利用規約に同意してください',
    '用户名和密码必填': 'ユーザー名とパスワードは必須です',
    '密码至少6位': 'パスワードは6文字以上必要です',
    '两次密码不一致': 'パスワードが一致しません',
    '用户名已存在': 'このユーザー名は既に使われています',
    '注册失败': '登録に失敗しました',
    '注册成功！': '登録が完了しました！',
    '欢迎，{name}！': 'ようこそ、{name} さん！',
    '用户名或密码错误': 'ユーザー名またはパスワードが違います',
    '登录尝试过多，请 {n} 分钟后再试': 'ログイン試行が多すぎます。{n}分後に再試行してください。',
    '已退出': 'ログアウトしました',
    '头像上传失败': 'アバターのアップロードに失敗しました',
    '上传失败': 'アップロードに失敗しました',
    '提交失败': '送信に失敗しました',
    '资料已提交，等待管理员审核': '送信しました。管理者の承認をお待ちください',
    '已有此枪械': 'この銃は既に追加されています',
    '{name} 已添加！': '{name} を追加しました！',
    '删除 {name}？其下所有改装码也会被删除！': '{name} を削除しますか？配下のすべての改造コードも削除されます！',
    '已删除': '削除しました',
    '请填写改枪码': '改造コードを入力してください',
    '已提交，等待管理员审核': '送信しました。管理者の承認をお待ちください',
    '确定删除？': '本当に削除しますか？',
    '更新成功！': '更新しました！',
    '加载社区数据...': 'コミュニティを読み込み中...',
    '加载枪械数据中...': '銃データを読み込み中...',
    '返回社区': 'コミュニティに戻る',
    '{name} 的改枪码': '{name} の改造コード',
    '点击改枪码即可复制 · {g} 把武器 · {v} 个配置': 'コードをクリックでコピー · 銃{g}丁 · 構成{v}件',
    '添加枪械与改枪码': '銃と改造コードを追加',
    '搜索枪械（从官方目录添加）': '銃を検索（公式カタログから追加）',
    '输入枪名，如 AKM、M4A1...': '銃名を入力（例：AKM、M4A1）...',
    '添加': '追加',
    '选择枪械添加改枪码': '銃を選んで改造コードを追加',
    '-- 选择枪械 --': '-- 銃を選択 --',
    '({n}个配置)': '（構成{n}件）',
    '段位': 'ティア',
    '不选': '選択なし',
    '价格': '価格',
    '类型': 'タイプ',
    '满改': 'フル改造',
    '52米': '52m',
    '射程': '射程',
    '改枪码 *': '改造コード *',
    '粘贴改枪码': '改造コードを貼り付け',
    '添加改枪码': '改造コードを追加',
    '全部段位': '全ティア',
    '默认排序': 'デフォルト順',
    '还没有枪械，使用上方搜索框添加': 'まだ銃がありません。上の検索欄から追加してください',
    '没有找到匹配的枪械': '一致する銃が見つかりません',
    '{n} 个配置方案': '{n}件の構成',
    '删除枪械': '銃を削除',
    '改装类型': '改造タイプ',
    '改枪码': '改造コード',
    '有效射程': '有効射程',
    '操作': '操作',
    '存': '保存', '消': '取消', '编': '編集', '删': '削除',
    '待审核': '審査中',
    '三角洲行动玩家改枪码分享社区，注册分享你的武器配置方案，交流改枪心得。': 'デルタフォースのプレイヤー改造コード共有コミュニティ。登録して自分の武器構成を共有し、情報交換しましょう。',
    '退出': 'ログアウト',
    '登录': 'ログイン',
    '注册': '新規登録',
    '分享和发现玩家的改枪方案 · 点击作者查看改枪码': 'プレイヤーの構成を共有・発見 · 作者をクリックでコードを表示',
    '搜索玩家...': 'プレイヤーを検索...',
    '我的改枪码': 'マイ改造コード',
    '还没有人分享改枪码': 'まだ誰も改造コードを共有していません',
    '点击上方按钮开始添加！': '上のボタンをクリックして追加を始めましょう！',
    '登录后即可创建改枪方案': 'ログインすると構成を作成できます',
    '我': '自分',
    '{n} 把武器': '銃{n}丁',
    '{n} 个配置': '構成{n}件',
    '用户名': 'ユーザー名',
    '密码': 'パスワード',
    '（至少6位）': '（6文字以上）',
    '确认密码': 'パスワード確認',
    '再次输入密码': 'パスワードを再入力',
    '密码一致': 'パスワードが一致',
    '昵称（选填）': 'ニックネーム（任意）',
    '昵称': 'ニックネーム',
    '我已阅读并同意': '以下に同意します：',
    '《用户协议》': '利用規約',
    '和': '・',
    '《隐私政策》': 'プライバシーポリシー',
    '个人资料': 'プロフィール',
    '你有一份资料修改正在审核中，审核通过后自动生效': 'プロフィールの変更が審査中です。承認されると自動的に反映されます',
    '显示名称': '表示名',
    '个人简介': '自己紹介',
    '一句话介绍自己': '一言で自己紹介',
    '保存中...': '保存中...',
    '保存': '保存',
    '取消': 'キャンセル',
  },
  ko: {
    '首页': '홈',
    '主播同款改枪码': '스트리머 세팅',
    '官方热门改枪码': '공식 인기 코드',
    '玩家社区': '커뮤니티',
    '每日密码': '일일 코드',
    '特勤处制造利润': '제작 수익',
    '价格走势图': '가격 추이',
    '物品图鉴': '아이템 도감',
    '卡战备系统': '장비 카드',
    '官方地图工具': '전술 지도',
    '管理后台': '관리자',
    '有力气的改枪': '건 빌드',
    '有力气的改枪网站': '델타포스 건 코드',
    '三角洲行动改枪码大全': '델타포스 세팅 코드 모음',
    '隐私政策': '개인정보 처리방침',
    '使用条款': '이용약관',
    'Cookie 政策': '쿠키 정책',
    // ---- Landing ----
    '改枪码已复制！': '세팅 코드가 복사되었습니다!',
    '加载中...': '불러오는 중...',
    '有力气的改枪网站 - 三角洲行动(Delta Force)最全工具站：官方热门改枪码、主播同款改枪码、玩家社区分享、每日密码查询、特勤处制造利润计算、物品价格走势图、卡战备推荐系统。': '델타포스 건 코드 - 올인원 도구: 공식 인기 코드, 스트리머 세팅, 커뮤니티 공유, 일일 코드, 제작 수익 계산, 가격 추이, 장비 추천.',
    '改枪码 · 每日密码 · 制造利润 · 价格走势 · 卡战备': '세팅 코드 · 일일 코드 · 제작 수익 · 가격 추이 · 장비',
    '官方改枪码': '공식 코드',
    '官方主播': '스트리머',
    '自定义枪械': '커스텀 총기',
    '改枪配置': '세팅',
    '主播改枪码': '스트리머 코드',
    '官方热门': '공식 인기',
    '制造利润': '제작 수익',
    '卡战备': '장비',
    '价格走势': '가격 추이',
    '今日密码': '오늘의 코드',
    '查看全部': '전체 보기',
    '今日最赚': '오늘의 최고 수익',
    '热门主播': '인기 스트리머',
    '{n}方案': '{n}개 세팅',
    '{n}使用': '{n}회 사용',
    '热门改枪码': '인기 세팅 코드',
    // ---- MapTool ----
    '三角洲行动官方互动地图，查看物资点、出生点、撤离点、首领坐标等关键信息。': '델타포스 공식 인터랙티브 지도 - 물자 지점, 스폰, 탈출 지점, 보스 좌표 확인.',
    '三角洲行动官方互动地图 · 物资点 · 出生点 · 撤离点 · 首领坐标': '공식 인터랙티브 지도 · 물자 · 스폰 · 탈출 · 보스',
    '新窗口打开': '새 창에서 열기',
    '加载地图中...': '지도 불러오는 중...',
    '地图无法嵌入显示': '지도를 삽입해 표시할 수 없습니다',
    '官方地图可能不支持嵌入，请点击下方按钮直接访问': '공식 지도는 삽입을 지원하지 않을 수 있습니다. 아래 버튼으로 직접 접속하세요.',
    '打开官方地图工具': '공식 지도 열기',
    '提示：': '팁: ',
    '地图数据来自腾讯官方。如果显示异常，点击右上角"新窗口打开"直接访问。': '지도 데이터는 텐센트 공식 제공입니다. 표시가 이상하면 오른쪽 상단 "새 창에서 열기"로 접속하세요.',
    // ---- DailyPassword ----
    '{name} 密码已复制！': '{name} 코드가 복사되었습니다!',
    '加载每日密码中...': '일일 코드 불러오는 중...',
    '三角洲行动每日地图密码查询，零号大坝、长弓溪谷、巴克什、航天基地、潮汐监狱每日更新。': '델타포스 일일 지도 코드 - 모든 지도 매일 업데이트.',
    '更新时间：': '업데이트: ',
    '暂无数据': '데이터 없음',
    '（非今日数据）': '(오늘 데이터 아님)',
    '今日密码暂未更新': '오늘의 코드가 아직 업데이트되지 않았습니다',
    '密码每天 00:00 自动更新，请稍后再来查看': '코드는 매일 00:00에 자동 업데이트됩니다. 나중에 다시 확인하세요.',
    '已复制': '복사됨',
    '点击复制密码': '클릭하여 코드 복사',
    // map names
    '零号大坝': '제로 댐', '长弓溪谷': '롱보우 계곡', '巴克什': '브라케시', '航天基地': '스페이스 시티', '潮汐监狱': '조석 감옥',
    // weapon / item categories
    '突击步枪': '돌격소총', '战斗步枪': '전투소총', '射手步枪': '지정사수소총', '冲锋枪': '기관단총', '机枪': '기관총', '狙击步枪': '저격소총', '连狙': '반자동 저격', '霰弹枪': '샷건', '手枪': '권총', '弓弩': '활/석궁', '子弹': '탄약', '医疗': '의료',
    '密码每天 00:00 自动更新。点击密码卡片可以快速复制。': '코드는 매일 00:00에 자동 업데이트됩니다. 카드를 클릭하면 빠르게 복사됩니다.',
    // ---- ItemCatalog ----
    '传说': '전설', '史诗': '영웅', '稀有': '희귀', '精良': '고급', '普通': '일반', '简陋': '조악', '无': '없음',
    '物资道具': '물자', '枪械': '총기', '配件': '부착물', '护甲': '방어구', '装备': '장비', '近战': '근접',
    '全部': '전체',
    '{n}级': '{n}등급',
    '加载物品数据...': '아이템 불러오는 중...',
    '返回物品列表': '아이템 목록으로',
    '产出地点：': '획득처: ',
    '重量：': '무게: ',
    '尺寸：': '크기: ',
    '三角洲行动全物品图鉴百科，收录所有枪械、配件、护甲、装备的详细信息和价格。': '델타포스 전체 아이템 도감 - 모든 총기, 부착물, 방어구, 장비의 상세 정보와 가격.',
    '三角洲行动所有物品信息 · {n} 个物品': '전체 아이템 정보 · {n}개',
    '搜索物品名称、描述、产出地...': '아이템 이름, 설명, 획득처 검색...',
    '全部品级': '전체 등급',
    '品级 高→低': '등급 높음→낮음',
    '价格 高→低': '가격 높음→낮음',
    '价格 低→高': '가격 낮음→높음',
    '名称排序': '이름순',
    '找到 {n} 个物品': '{n}개 찾음',
    '没有找到匹配的物品': '일치하는 아이템이 없습니다',
    // ---- Legal ----
    '法律声明': '법적 고지',
    '有力气的改枪网站的隐私政策、使用条款和Cookie政策。': '델타포스 건 코드의 개인정보 처리방침, 이용약관, 쿠키 정책.',
    '最后更新：2026年3月13日': '최종 업데이트: 2026년 3월 13일',
    '欢迎访问有力气的改枪网站（以下简称"本站"，网址：guns.yufantechs.com）。本站由 YufanTechs 运营。我们非常重视您的隐私，本隐私政策旨在说明我们如何收集、使用和保护您的信息。': '델타포스 건 코드(이하 "본 사이트", guns.yufantechs.com)에 오신 것을 환영합니다. 본 사이트는 YufanTechs가 운영합니다. 저희는 이용자의 개인정보를 중시하며, 본 방침은 정보를 수집·이용·보호하는 방법을 설명합니다.',
    '1. 信息收集': '1. 정보 수집',
    '1.1 您主动提供的信息': '1.1 이용자가 제공하는 정보',
    '注册信息：当您在玩家社区注册账号时，我们会收集您的用户名和密码': '가입 정보: 커뮤니티에 가입할 때 사용자명과 비밀번호를 수집합니다.',
    '发布内容：您发布的改枪码、评论等内容': '게시 내용: 게시한 세팅 코드, 댓글 등.',
    '管理员信息：管理员登录所需的用户名和密码': '관리자 정보: 관리자 로그인에 필요한 사용자명과 비밀번호.',
    '1.2 自动收集的信息': '1.2 자동으로 수집되는 정보',
    '访问日志：包括 IP 地址、浏览器类型、访问时间等基本信息（由 Netlify 托管平台自动记录）': '접속 로그: IP 주소, 브라우저 종류, 접속 시간 등 기본 정보(Netlify 호스팅에서 자동 기록).',
    '本站不使用任何第三方分析工具或广告追踪': '본 사이트는 제3자 분석 도구나 광고 추적을 일절 사용하지 않습니다.',
    '2. 信息使用': '2. 정보 이용',
    '我们收集的信息仅用于以下目的：': '수집한 정보는 다음 목적으로만 사용됩니다:',
    '提供和改善本站服务': '서비스 제공 및 개선.',
    '管理用户账号和权限': '사용자 계정 및 권한 관리.',
    '展示用户发布的改枪码内容': '이용자가 게시한 세팅 코드 표시.',
    '维护网站安全和稳定运行': '사이트 보안 및 안정적 운영 유지.',
    '3. 信息存储与安全': '3. 정보 보관 및 보안',
    '数据存储在 Supabase（加拿大数据中心）提供的安全数据库中': '데이터는 Supabase(캐나다 데이터센터)가 제공하는 보안 데이터베이스에 저장됩니다.',
    '密码以明文形式存储（注意：我们建议您不要使用与其他重要账号相同的密码）': '비밀번호는 평문으로 저장됩니다(주의: 다른 중요한 계정과 동일한 비밀번호 사용은 권장하지 않습니다).',
    '我们采取合理的技术措施保护您的数据安全': '데이터 보안을 위해 합리적인 기술적 조치를 취합니다.',
    '4. 信息共享': '4. 정보 공유',
    '我们不会将您的个人信息出售、出租或以其他方式分享给任何第三方，除非：': '다음의 경우를 제외하고 개인정보를 제3자에게 판매·대여·공유하지 않습니다:',
    '获得您的明确同意': '이용자의 명시적 동의가 있는 경우.',
    '法律法规要求': '법령에서 요구하는 경우.',
    '保护本站或其用户的合法权益': '본 사이트 또는 이용자의 정당한 권익을 보호하는 경우.',
    '5. 第三方服务': '5. 제3자 서비스',
    '本站使用以下第三方服务：': '본 사이트는 다음 제3자 서비스를 이용합니다:',
    'Supabase：数据库和后端服务': 'Supabase: 데이터베이스 및 백엔드 서비스.',
    'Netlify：网站托管和部署': 'Netlify: 웹사이트 호스팅 및 배포.',
    '腾讯 AMS API：获取游戏相关数据（每日密码、物品价格等）': 'Tencent AMS API: 게임 관련 데이터(일일 코드, 아이템 가격 등) 수집.',
    '6. 您的权利': '6. 이용자의 권리',
    '您有权：': '이용자는 다음 권리를 가집니다:',
    '访问您的个人信息': '개인정보에 접근할 권리.',
    '删除您的账号和相关数据': '계정 및 관련 데이터를 삭제할 권리.',
    '撤回您发布的内容': '게시한 내용을 철회할 권리.',
    '7. 未成年人保护': '7. 미성년자 보호',
    '本站不针对 13 岁以下的儿童提供服务。如果您发现有未成年人在未经家长同意的情况下提供了个人信息，请联系我们。': '본 사이트는 만 13세 미만 아동을 대상으로 하지 않습니다. 미성년자가 보호자 동의 없이 개인정보를 제공한 것을 발견하면 저희에게 연락해 주세요.',
    '8. 政策更新': '8. 방침 업데이트',
    '我们可能会不定期更新本隐私政策。更新后的政策将在本页面发布，建议您定期查看。': '본 방침은 수시로 업데이트될 수 있습니다. 업데이트된 방침은 본 페이지에 게시되며, 정기적으로 확인하시기 바랍니다.',
    '9. 联系我们': '9. 문의',
    '如果您对本隐私政策有任何疑问，请通过以下方式联系我们：': '본 방침에 대해 문의가 있으시면 아래로 연락해 주세요:',
    '网站：guns.yufantechs.com': '웹사이트: guns.yufantechs.com',
    '请在使用本站服务之前仔细阅读以下条款。使用本站即表示您同意受这些条款的约束。': '본 사이트를 이용하기 전에 다음 약관을 주의 깊게 읽어 주세요. 사이트를 이용하면 본 약관에 동의한 것으로 간주됩니다.',
    '1. 服务说明': '1. 서비스 안내',
    '有力气的改枪网站是一个面向《三角洲行动》（Delta Force）玩家的第三方工具网站，提供以下服务：': '델타포스 건 코드는 『델타포스(Delta Force)』 플레이어를 위한 제3자 도구 사이트로, 다음 서비스를 제공합니다:',
    '改枪码分享与浏览': '세팅 코드 공유 및 열람.',
    '每日密码查询': '일일 코드 조회.',
    '特勤处制造利润计算': '제작 수익 계산.',
    '物品价格走势查询': '아이템 가격 추이 조회.',
    '卡战备推荐系统': '장비 추천 시스템.',
    '玩家社区功能': '커뮤니티 기능.',
    '2. 免责声明': '2. 면책 조항',
    '本站为非官方第三方工具，与腾讯、Team Jade 或三角洲行动官方无任何关联': '본 사이트는 비공식 제3자 도구이며 텐센트, Team Jade 또는 델타포스 공식과 아무런 관련이 없습니다.',
    '本站提供的数据来源于公开 API，仅供参考，不保证实时性和准确性': '본 사이트의 데이터는 공개 API에서 제공되는 참고용이며 실시간성과 정확성을 보장하지 않습니다.',
    '因游戏更新导致的数据偏差，本站不承担任何责任': '게임 업데이트로 인한 데이터 오차에 대해 본 사이트는 책임지지 않습니다.',
    '使用本站提供的改枪码或其他信息所产生的任何后果，由用户自行承担': '본 사이트의 세팅 코드 등 정보 이용으로 발생한 결과는 이용자 본인이 부담합니다.',
    '3. 用户行为规范': '3. 이용자 행동 규범',
    '使用本站服务时，您同意：': '본 사이트 이용 시 다음에 동의합니다:',
    '不发布违法、色情、暴力、仇恨或其他不当内容': '불법·음란·폭력·혐오 또는 기타 부적절한 콘텐츠를 게시하지 않습니다.',
    '不冒充他人或虚假宣传': '타인을 사칭하거나 허위 홍보를 하지 않습니다.',
    '不利用本站进行任何商业行为（未经授权）': '무단으로 본 사이트를 상업적 목적에 이용하지 않습니다.',
    '不尝试攻击、破坏或干扰本站的正常运行': '본 사이트의 정상 운영을 공격·훼손·방해하려 하지 않습니다.',
    '不批量爬取或自动化访问本站数据': '본 사이트 데이터를 대량 크롤링하거나 자동화 접근하지 않습니다.',
    '4. 知识产权': '4. 지식재산권',
    '《三角洲行动》的商标、图像和游戏数据归腾讯及 Team Jade 所有': '『델타포스』의 상표·이미지·게임 데이터는 텐센트 및 Team Jade에 귀속됩니다.',
    '本站的界面设计和代码归 YufanTechs 所有': '본 사이트의 UI 디자인 및 코드는 YufanTechs에 귀속됩니다.',
    '用户发布的改枪码内容归发布者所有': '이용자가 게시한 세팅 코드는 게시자에게 귀속됩니다.',
    '5. 账号管理': '5. 계정 관리',
    '您有责任保护自己的账号安全': '본인 계정의 보안을 지킬 책임이 있습니다.',
    '我们保留在违反使用条款时封禁或删除账号的权利': '약관 위반 시 계정을 정지하거나 삭제할 권리를 보유합니다.',
    '长期不活跃的账号可能会被清理': '장기간 비활성 계정은 정리될 수 있습니다.',
    '6. 服务变更与终止': '6. 서비스 변경 및 종료',
    '我们保留在任何时候修改、暂停或终止本站服务的权利，恕不另行通知。对于服务变更或终止造成的任何损失，本站不承担责任。': '본 사이트는 언제든지 예고 없이 서비스를 변경·중단·종료할 권리를 보유합니다. 이로 인한 손실에 대해 책임지지 않습니다.',
    '7. 条款修改': '7. 약관 변경',
    '我们可能会不定期修改本使用条款。修改后的条款将在本页面发布并立即生效。继续使用本站即表示您接受修改后的条款。': '본 약관은 수시로 변경될 수 있습니다. 변경된 약관은 본 페이지에 게시되어 즉시 발효됩니다. 계속 이용하면 변경된 약관에 동의한 것으로 간주됩니다.',
    '1. 什么是 Cookie': '1. 쿠키란',
    'Cookie 是网站存储在您浏览器中的小型文本文件，用于记录您的偏好和使用信息。': '쿠키는 웹사이트가 브라우저에 저장하는 작은 텍스트 파일로, 이용자의 설정과 이용 정보를 기록합니다.',
    '2. 本站使用的存储方式': '2. 본 사이트의 저장 방식',
    '本站主要使用浏览器的 LocalStorage（本地存储）来保存以下信息：': '본 사이트는 주로 브라우저의 LocalStorage를 이용해 다음 정보를 저장합니다:',
    '玩家登录状态': '플레이어 로그인 상태',
    '：记住您的登录信息，避免每次访问都需要重新登录（存储键：df_player）': ': 로그인 정보를 기억해 방문할 때마다 다시 로그인할 필요가 없게 합니다(저장 키: df_player).',
    '3. 本站不使用的技术': '3. 본 사이트가 사용하지 않는 기술',
    '本站不使用第三方 Cookie': '본 사이트는 제3자 쿠키를 사용하지 않습니다.',
    '本站不使用广告追踪 Cookie': '본 사이트는 광고 추적 쿠키를 사용하지 않습니다.',
    '本站不使用任何分析追踪工具（如 Google Analytics）': '본 사이트는 분석 추적 도구(Google Analytics 등)를 일절 사용하지 않습니다.',
    '本站不进行跨站追踪': '본 사이트는 교차 사이트 추적을 하지 않습니다.',
    '4. 第三方 Cookie': '4. 제3자 쿠키',
    '本站嵌入的官方地图工具（iframe）可能会设置来自 df.qq.com 的 Cookie，这些 Cookie 由腾讯控制，不在本站管理范围内。': '삽입된 공식 지도 도구(iframe)는 df.qq.com의 쿠키를 설정할 수 있습니다. 이 쿠키는 텐센트가 관리하며 본 사이트의 관리 범위 밖입니다.',
    '5. 如何管理': '5. 관리 방법',
    '您可以通过以下方式管理存储数据：': '다음 방법으로 저장 데이터를 관리할 수 있습니다:',
    '在玩家社区页面点击"退出"清除登录数据': '커뮤니티 페이지에서 "로그아웃"을 클릭해 로그인 데이터를 삭제합니다.',
    '在浏览器设置中清除本站的 LocalStorage 数据': '브라우저 설정에서 본 사이트의 LocalStorage 데이터를 삭제합니다.',
    '使用浏览器的隐私/无痕模式访问本站': '브라우저의 시크릿/프라이빗 모드로 본 사이트를 이용합니다.',
    '如果我们更改了数据存储方式，将更新本 Cookie 政策并在本页面发布。': '데이터 저장 방식을 변경하면 본 쿠키 정책을 업데이트하여 본 페이지에 게시합니다.',
    // ---- Loadout ----
    '加载战备数据中...': '장비 데이터 불러오는 중...',
    '暂无战备数据': '장비 데이터가 없습니다',
    '头盔': '헬멧', '胸挂': '체스트 리그', '背包': '배낭',
    '推荐配件': '추천 부착물',
    '购买成本': '구매 비용', '装备价值': '장비 가치', '配件价值': '부착물 가치', '总估值': '총 평가액',
    '三角洲行动卡战备配装推荐，不同预算档位的最优枪械、护甲、装备搭配方案。': '델타포스 장비 추천 - 예산대별 최적의 총기, 방어구, 장비 조합.',
    '更新：': '업데이트: ',
    '价格基于交易行实时均价，每小时更新 · 含配件推荐': '가격은 거래소 실시간 평균 기준, 매시간 업데이트 · 부착물 추천 포함',
    '大坝、长弓机密': '댐·롱보우 기밀',
    '巴克什、航天机密': '브라케시·우주기지 기밀',
    '潮汐监狱-适应': '조석 감옥·적응',
    '巴克什-绝密': '브라케시·특급기밀',
    '航天基地-绝密': '우주기지·특급기밀',
    '潮汐监狱-绝密': '조석 감옥·특급기밀',
    '策略方案': '전략 세팅', '多枪方案': '멀티건 세팅',
    '该档位暂无{type}方案': '이 등급의 {type} 세팅이 없습니다',
    '策略': '전략', '多枪': '멀티건',
    '说明：': '설명: ',
    '：🔫枪械拉满 / ⚖️均衡 / 🦺胸挂拉满 / 🏃轻装跑图（少配件轻装，适合跑图丢包场景）。': ': 🔫화력 특화 / ⚖️밸런스 / 🦺리그 특화 / 🏃경장(부착물 적은 경장, 파밍·투척 상황에 적합).',
    '：不同枪械+最优装备组合。': ': 다양한 총기 + 최적 장비 조합.',
    '配件': '부착물',
    '：点击展开查看推荐配件，价值已计入总估值。': ': 클릭하면 추천 부착물이 펼쳐지며, 가치는 총 평가액에 포함됩니다.',
    '品级：': '등급: ',
    // ---- Streamers ----
    '加载主播数据...': '스트리머 데이터 불러오는 중...',
    '返回主播列表': '스트리머 목록으로',
    '{n} 个方案 · {apply} 使用 · 点击展开查看配件': '{n}개 세팅 · {apply}회 사용 · 탭하여 부착물 보기',
    '搜索枪名或方案名...': '총기명 또는 세팅명 검색...',
    '{n} 赞': '좋아요 {n}',
    '配件详情': '부착물 상세',
    '配件总价：': '부착물 합계: ',
    '无配件数据': '부착물 데이터 없음',
    '复制改枪码': '세팅 코드 복사',
    '三角洲行动主播改枪码合集，热门主播同款武器配置方案，一键复制使用。': '델타포스 스트리머 세팅 코드 모음. 인기 스트리머의 무기 세팅을 원터치 복사.',
    '来自官方社区 · {n} 位主播 · {c} 个方案': '공식 커뮤니티 · 스트리머 {n}명 · 세팅 {c}개',
    '搜索主播名称...': '스트리머 이름 검색...',
    '没有找到「{q}」相关的主播': '"{q}"에 해당하는 스트리머가 없습니다',
    '{n} 个方案': '{n}개 세팅',
    '{n} 使用': '{n}회 사용',
    // ---- Gun landing pages ----
    '武器改枪码大全': '무기별 세팅 코드',
    '武器改枪码': '무기 세팅 코드',
    '三角洲行动武器改枪码': '델타포스 무기 세팅 코드',
    '三角洲行动各热门武器的改枪码大全，按武器查询官方与主播同款改枪码，一键复制。': '델타포스 인기 무기별 세팅 코드. 무기별로 공식·스트리머 코드를 검색해 원터치 복사.',
    '按武器查询三角洲行动改枪码 · 共 {n} 把武器': '무기별 델타포스 세팅 코드 검색 · 총 {n}개',
    '「{model}」改枪码大全': '{model} 세팅 코드',
    '「{model}」改枪码': '{model} 세팅 코드',
    '「{model}」三角洲改枪码大全，收录该武器的官方与主播同款改枪码，一键复制导入游戏。': '{model} 델타포스 세팅 코드 모음. 이 무기의 공식·스트리머 코드를 수록, 원터치 복사.',
    // ---- OfficialCodes ----
    '加载官方改枪码...': '공식 코드 불러오는 중...',
    '三角洲行动官方社区热门改枪码，按使用量排行，含完整配件列表和价格。': '델타포스 공식 커뮤니티 인기 세팅 코드. 사용량순 정렬, 전체 부착물 목록과 가격 포함.',
    '来自官方社区 · {c} 个方案 · 点击展开查看配件 · 同步：{time}': '공식 커뮤니티 · 세팅 {c}개 · 탭하여 부착물 보기 · 동기화: {time}',
    '搜索枪名、方案名、作者...': '총기명, 세팅명, 작성자 검색...',
    '使用量 高→低': '사용량 높음→낮음',
    '点赞 高→低': '좋아요 높음→낮음',
    '配件列表': '부착물 목록',
    '此方案无配件数据': '이 세팅에 부착물 데이터가 없습니다',
    '点击卡片展开查看配件详情。点击改枪码直接复制。数据每6小时自动同步。': '카드를 탭하면 부착물 상세가 펼쳐집니다. 코드를 탭하면 복사됩니다. 데이터는 6시간마다 자동 동기화됩니다.',
    // ---- PriceTrend ----
    '需要至少2天数据才能显示走势图': '추이 그래프를 표시하려면 최소 2일치 데이터가 필요합니다',
    '系统每天自动记录价格，过几天就有图了': '시스템이 매일 가격을 기록합니다. 며칠 후 그래프가 나타납니다',
    '加载价格数据中...': '가격 데이터 불러오는 중...',
    '三角洲行动物品价格走势图，实时追踪枪械、护甲、配件等物品的历史价格变化。': '델타포스 아이템 가격 추이. 총기, 방어구, 부착물 등의 과거 가격 변동을 추적.',
    '更新日期：': '업데이트 날짜: ',
    '共 {n} 个物品': '총 {n}개',
    '搜索物品名称...': '아이템 이름 검색...',
    '暂无价格数据': '가격 데이터가 없습니다',
    '请管理员在后台获取价格数据': '관리자가 백엔드에서 가격 데이터를 가져와야 합니다',
    '价格为交易行均价，每天自动更新。点击物品可查看历史走势图。涨跌幅对比前一天数据。数据积累越多，走势图越完整。': '가격은 거래소 평균가로 매일 자동 업데이트됩니다. 아이템을 클릭하면 과거 추이 그래프를 볼 수 있습니다. 등락은 전일 대비입니다. 데이터가 쌓일수록 그래프가 완성됩니다.',
    // ---- Manufacturing ----
    '加载制造数据中...': '제작 데이터 불러오는 중...',
    '暂无制造数据': '제작 데이터가 없습니다',
    '请管理员在后台获取数据': '관리자가 백엔드에서 데이터를 가져와야 합니다',
    '三角洲行动特勤处制造利润计算器，实时制造成本与收益分析，找到最赚钱的制造方案。': '델타포스 제작 수익 계산기. 실시간 제작 비용과 수익 분석으로 가장 돈이 되는 레시피를 찾으세요.',
    '共 {n} 个制造方案': '총 {n}개 레시피',
    '各部门最赚推荐': '시설별 최고 추천',
    '技术中心': '기술 센터', '工作台': '작업대', '制药台': '제약대', '防具台': '방어구대',
    '净利润': '순수익',
    '每小时 {a} · 售价 {b}': '시간당 {a} · 판매가 {b}',
    '总利润 高→低': '총 수익 높음→낮음',
    '利润/小时 高→低': '시간당 수익 높음→낮음',
    '售价 高→低': '판매가 높음→낮음',
    '耗时 短→长': '소요 시간 짧음→긺',
    '售价': '판매가', '成本': '비용', '每小时': '시간당', '总利润': '총 수익',
    '总利润 = 售价 - 材料成本 - 手续费。品级颜色：': '총 수익 = 판매가 − 재료비 − 수수료. 등급 색상:',
    // ---- Community ----
    '包含违规内容「{w}」': '에 금지된 내용 "{w}"이(가) 포함되어 있습니다',
    '不允许包含手机号': '에 전화번호를 포함할 수 없습니다',
    '不允许包含邮箱地址': '에 이메일 주소를 포함할 수 없습니다',
    '不允许包含网址链接': '에 URL을 포함할 수 없습니다',
    '不允许包含联系方式': '에 연락처를 포함할 수 없습니다',
    '用户名{msg}': '사용자명{msg}',
    '昵称{msg}': '닉네임{msg}',
    '简介{msg}': '소개{msg}',
    '请先同意用户协议': '먼저 이용약관에 동의해 주세요',
    '用户名和密码必填': '사용자명과 비밀번호는 필수입니다',
    '密码至少6位': '비밀번호는 최소 6자 이상이어야 합니다',
    '两次密码不一致': '비밀번호가 일치하지 않습니다',
    '用户名已存在': '이미 사용 중인 사용자명입니다',
    '注册失败': '가입에 실패했습니다',
    '注册成功！': '가입이 완료되었습니다!',
    '欢迎，{name}！': '{name}님 환영합니다!',
    '用户名或密码错误': '사용자명 또는 비밀번호가 올바르지 않습니다',
    '登录尝试过多，请 {n} 分钟后再试': '로그인 시도가 너무 많습니다. {n}분 후에 다시 시도하세요.',
    '已退出': '로그아웃되었습니다',
    '头像上传失败': '프로필 사진 업로드에 실패했습니다',
    '上传失败': '업로드에 실패했습니다',
    '提交失败': '제출에 실패했습니다',
    '资料已提交，等待管理员审核': '제출되었습니다. 관리자 승인을 기다려 주세요',
    '已有此枪械': '이미 추가된 총기입니다',
    '{name} 已添加！': '{name}이(가) 추가되었습니다!',
    '删除 {name}？其下所有改装码也会被删除！': '{name}을(를) 삭제할까요? 하위의 모든 세팅 코드도 삭제됩니다!',
    '已删除': '삭제되었습니다',
    '请填写改枪码': '세팅 코드를 입력해 주세요',
    '已提交，等待管理员审核': '제출되었습니다. 관리자 승인을 기다려 주세요',
    '确定删除？': '정말 삭제할까요?',
    '更新成功！': '업데이트되었습니다!',
    '加载社区数据...': '커뮤니티 불러오는 중...',
    '加载枪械数据中...': '총기 데이터 불러오는 중...',
    '返回社区': '커뮤니티로',
    '{name} 的改枪码': '{name}님의 세팅 코드',
    '点击改枪码即可复制 · {g} 把武器 · {v} 个配置': '코드를 클릭하면 복사 · 총기 {g}개 · 세팅 {v}개',
    '添加枪械与改枪码': '총기 및 세팅 코드 추가',
    '搜索枪械（从官方目录添加）': '총기 검색(공식 목록에서 추가)',
    '输入枪名，如 AKM、M4A1...': '총기 이름 입력, 예: AKM, M4A1...',
    '添加': '추가',
    '选择枪械添加改枪码': '총기를 선택해 세팅 코드 추가',
    '-- 选择枪械 --': '-- 총기 선택 --',
    '({n}个配置)': '(세팅 {n}개)',
    '段位': '티어',
    '不选': '선택 안 함',
    '价格': '가격',
    '类型': '유형',
    '满改': '풀 세팅',
    '52米': '52m',
    '射程': '사거리',
    '改枪码 *': '세팅 코드 *',
    '粘贴改枪码': '세팅 코드 붙여넣기',
    '添加改枪码': '세팅 코드 추가',
    '全部段位': '전체 티어',
    '默认排序': '기본 정렬',
    '还没有枪械，使用上方搜索框添加': '아직 총기가 없습니다. 위 검색창으로 추가하세요',
    '没有找到匹配的枪械': '일치하는 총기가 없습니다',
    '{n} 个配置方案': '{n}개 세팅',
    '删除枪械': '총기 삭제',
    '改装类型': '세팅 유형',
    '改枪码': '세팅 코드',
    '有效射程': '유효 사거리',
    '操作': '작업',
    '存': '저장', '消': '취소', '编': '수정', '删': '삭제',
    '待审核': '검토 대기',
    '三角洲行动玩家改枪码分享社区，注册分享你的武器配置方案，交流改枪心得。': '델타포스 플레이어 세팅 코드 공유 커뮤니티. 가입하여 무기 세팅을 공유하고 정보를 나누세요.',
    '退出': '로그아웃',
    '登录': '로그인',
    '注册': '회원가입',
    '分享和发现玩家的改枪方案 · 点击作者查看改枪码': '플레이어 세팅을 공유하고 발견하세요 · 작성자를 클릭하면 코드를 볼 수 있습니다',
    '搜索玩家...': '플레이어 검색...',
    '我的改枪码': '내 세팅 코드',
    '还没有人分享改枪码': '아직 아무도 세팅 코드를 공유하지 않았습니다',
    '点击上方按钮开始添加！': '위 버튼을 클릭해 추가를 시작하세요!',
    '登录后即可创建改枪方案': '로그인하면 세팅을 만들 수 있습니다',
    '我': '나',
    '{n} 把武器': '총기 {n}개',
    '{n} 个配置': '세팅 {n}개',
    '用户名': '사용자명',
    '密码': '비밀번호',
    '（至少6位）': ' (6자 이상)',
    '确认密码': '비밀번호 확인',
    '再次输入密码': '비밀번호 재입력',
    '密码一致': '비밀번호 일치',
    '昵称（选填）': '닉네임(선택)',
    '昵称': '닉네임',
    '我已阅读并同意': '다음에 동의합니다:',
    '《用户协议》': '이용약관',
    '和': '및',
    '《隐私政策》': '개인정보 처리방침',
    '个人资料': '프로필',
    '你有一份资料修改正在审核中，审核通过后自动生效': '프로필 변경이 검토 중입니다. 승인되면 자동으로 적용됩니다',
    '显示名称': '표시 이름',
    '个人简介': '소개',
    '一句话介绍自己': '한 줄로 자기소개',
    '保存中...': '저장 중...',
    '保存': '저장',
    '取消': '취소',
  },
  'zh-TW': {
    '首页': '首頁',
    '主播同款改枪码': '主播同款改槍碼',
    '官方热门改枪码': '官方熱門改槍碼',
    '玩家社区': '玩家社群',
    '每日密码': '每日密碼',
    '特勤处制造利润': '特勤處製造利潤',
    '价格走势图': '價格走勢圖',
    '物品图鉴': '物品圖鑑',
    '卡战备系统': '卡戰備系統',
    '官方地图工具': '官方地圖工具',
    '管理后台': '管理後台',
    '有力气的改枪': '有力氣的改槍',
    '有力气的改枪网站': '有力氣的改槍網站',
    '三角洲行动改枪码大全': '三角洲行動改槍碼大全',
    '隐私政策': '隱私政策',
    '使用条款': '使用條款',
    'Cookie 政策': 'Cookie 政策',
    // ---- Landing ----
    '改枪码已复制！': '改槍碼已複製！',
    '加载中...': '載入中...',
    '有力气的改枪网站 - 三角洲行动(Delta Force)最全工具站：官方热门改枪码、主播同款改枪码、玩家社区分享、每日密码查询、特勤处制造利润计算、物品价格走势图、卡战备推荐系统。': '有力氣的改槍網站 - 三角洲行動(Delta Force)最全工具站：官方熱門改槍碼、主播同款改槍碼、玩家社群分享、每日密碼查詢、特勤處製造利潤計算、物品價格走勢圖、卡戰備推薦系統。',
    '改枪码 · 每日密码 · 制造利润 · 价格走势 · 卡战备': '改槍碼 · 每日密碼 · 製造利潤 · 價格走勢 · 卡戰備',
    '官方改枪码': '官方改槍碼',
    '官方主播': '官方主播',
    '自定义枪械': '自訂槍械',
    '改枪配置': '改槍配置',
    '主播改枪码': '主播改槍碼',
    '官方热门': '官方熱門',
    '制造利润': '製造利潤',
    '卡战备': '卡戰備',
    '价格走势': '價格走勢',
    '今日密码': '今日密碼',
    '查看全部': '查看全部',
    '今日最赚': '今日最賺',
    '热门主播': '熱門主播',
    '{n}方案': '{n}方案',
    '{n}使用': '{n}使用',
    '热门改枪码': '熱門改槍碼',
    // ---- MapTool ----
    '三角洲行动官方互动地图，查看物资点、出生点、撤离点、首领坐标等关键信息。': '三角洲行動官方互動地圖，查看物資點、出生點、撤離點、首領座標等關鍵資訊。',
    '三角洲行动官方互动地图 · 物资点 · 出生点 · 撤离点 · 首领坐标': '三角洲行動官方互動地圖 · 物資點 · 出生點 · 撤離點 · 首領座標',
    '新窗口打开': '新視窗開啟',
    '加载地图中...': '載入地圖中...',
    '地图无法嵌入显示': '地圖無法嵌入顯示',
    '官方地图可能不支持嵌入，请点击下方按钮直接访问': '官方地圖可能不支援嵌入，請點擊下方按鈕直接存取',
    '打开官方地图工具': '開啟官方地圖工具',
    '提示：': '提示：',
    '地图数据来自腾讯官方。如果显示异常，点击右上角"新窗口打开"直接访问。': '地圖資料來自騰訊官方。如果顯示異常，點擊右上角「新視窗開啟」直接存取。',
    // ---- DailyPassword ----
    '{name} 密码已复制！': '{name} 密碼已複製！',
    '加载每日密码中...': '載入每日密碼中...',
    '三角洲行动每日地图密码查询，零号大坝、长弓溪谷、巴克什、航天基地、潮汐监狱每日更新。': '三角洲行動每日地圖密碼查詢，零號大壩、長弓溪谷、巴克什、航天基地、潮汐監獄每日更新。',
    '更新时间：': '更新時間：',
    '暂无数据': '暫無資料',
    '（非今日数据）': '（非今日資料）',
    '今日密码暂未更新': '今日密碼尚未更新',
    '密码每天 00:00 自动更新，请稍后再来查看': '密碼每天 00:00 自動更新，請稍後再來查看',
    '已复制': '已複製',
    '点击复制密码': '點擊複製密碼',
    // map names
    '零号大坝': '零號大壩', '长弓溪谷': '長弓溪谷', '巴克什': '巴克什', '航天基地': '航天基地', '潮汐监狱': '潮汐監獄',
    // weapon / item categories
    '突击步枪': '突擊步槍', '战斗步枪': '戰鬥步槍', '射手步枪': '射手步槍', '冲锋枪': '衝鋒槍', '机枪': '機槍', '狙击步枪': '狙擊步槍', '连狙': '連狙', '霰弹枪': '霰彈槍', '手枪': '手槍', '弓弩': '弓弩', '子弹': '子彈', '医疗': '醫療',
    '密码每天 00:00 自动更新。点击密码卡片可以快速复制。': '密碼每天 00:00 自動更新。點擊密碼卡片可以快速複製。',
    // ---- ItemCatalog ----
    '传说': '傳說', '史诗': '史詩', '稀有': '稀有', '精良': '精良', '普通': '普通', '简陋': '簡陋', '无': '無',
    '物资道具': '物資道具', '枪械': '槍械', '配件': '配件', '护甲': '護甲', '装备': '裝備', '近战': '近戰',
    '全部': '全部',
    '{n}级': '{n}級',
    '加载物品数据...': '載入物品資料...',
    '返回物品列表': '返回物品列表',
    '产出地点：': '產出地點：',
    '重量：': '重量：',
    '尺寸：': '尺寸：',
    '三角洲行动全物品图鉴百科，收录所有枪械、配件、护甲、装备的详细信息和价格。': '三角洲行動全物品圖鑑百科，收錄所有槍械、配件、護甲、裝備的詳細資訊和價格。',
    '三角洲行动所有物品信息 · {n} 个物品': '三角洲行動所有物品資訊 · {n} 個物品',
    '搜索物品名称、描述、产出地...': '搜尋物品名稱、描述、產出地...',
    '全部品级': '全部品級',
    '品级 高→低': '品級 高→低',
    '价格 高→低': '價格 高→低',
    '价格 低→高': '價格 低→高',
    '名称排序': '名稱排序',
    '找到 {n} 个物品': '找到 {n} 個物品',
    '没有找到匹配的物品': '沒有找到符合的物品',
    // ---- Legal ----
    '法律声明': '法律聲明',
    '有力气的改枪网站的隐私政策、使用条款和Cookie政策。': '有力氣的改槍網站的隱私政策、使用條款和 Cookie 政策。',
    '最后更新：2026年3月13日': '最後更新：2026年3月13日',
    '欢迎访问有力气的改枪网站（以下简称"本站"，网址：guns.yufantechs.com）。本站由 YufanTechs 运营。我们非常重视您的隐私，本隐私政策旨在说明我们如何收集、使用和保护您的信息。': '歡迎造訪有力氣的改槍網站（以下簡稱「本站」，網址：guns.yufantechs.com）。本站由 YufanTechs 營運。我們非常重視您的隱私，本隱私政策旨在說明我們如何收集、使用和保護您的資訊。',
    '1. 信息收集': '1. 資訊收集',
    '1.1 您主动提供的信息': '1.1 您主動提供的資訊',
    '注册信息：当您在玩家社区注册账号时，我们会收集您的用户名和密码': '註冊資訊：當您在玩家社群註冊帳號時，我們會收集您的使用者名稱和密碼。',
    '发布内容：您发布的改枪码、评论等内容': '發布內容：您發布的改槍碼、評論等內容。',
    '管理员信息：管理员登录所需的用户名和密码': '管理員資訊：管理員登入所需的使用者名稱和密碼。',
    '1.2 自动收集的信息': '1.2 自動收集的資訊',
    '访问日志：包括 IP 地址、浏览器类型、访问时间等基本信息（由 Netlify 托管平台自动记录）': '存取紀錄：包括 IP 位址、瀏覽器類型、存取時間等基本資訊（由 Netlify 託管平台自動記錄）。',
    '本站不使用任何第三方分析工具或广告追踪': '本站不使用任何第三方分析工具或廣告追蹤。',
    '2. 信息使用': '2. 資訊使用',
    '我们收集的信息仅用于以下目的：': '我們收集的資訊僅用於以下目的：',
    '提供和改善本站服务': '提供和改善本站服務。',
    '管理用户账号和权限': '管理使用者帳號和權限。',
    '展示用户发布的改枪码内容': '展示使用者發布的改槍碼內容。',
    '维护网站安全和稳定运行': '維護網站安全和穩定運作。',
    '3. 信息存储与安全': '3. 資訊儲存與安全',
    '数据存储在 Supabase（加拿大数据中心）提供的安全数据库中': '資料儲存在 Supabase（加拿大資料中心）提供的安全資料庫中。',
    '密码以明文形式存储（注意：我们建议您不要使用与其他重要账号相同的密码）': '密碼以明文形式儲存（注意：我們建議您不要使用與其他重要帳號相同的密碼）。',
    '我们采取合理的技术措施保护您的数据安全': '我們採取合理的技術措施保護您的資料安全。',
    '4. 信息共享': '4. 資訊共享',
    '我们不会将您的个人信息出售、出租或以其他方式分享给任何第三方，除非：': '我們不會將您的個人資訊出售、出租或以其他方式分享給任何第三方，除非：',
    '获得您的明确同意': '獲得您的明確同意。',
    '法律法规要求': '法律法規要求。',
    '保护本站或其用户的合法权益': '保護本站或其使用者的合法權益。',
    '5. 第三方服务': '5. 第三方服務',
    '本站使用以下第三方服务：': '本站使用以下第三方服務：',
    'Supabase：数据库和后端服务': 'Supabase：資料庫和後端服務。',
    'Netlify：网站托管和部署': 'Netlify：網站託管和部署。',
    '腾讯 AMS API：获取游戏相关数据（每日密码、物品价格等）': '騰訊 AMS API：取得遊戲相關資料（每日密碼、物品價格等）。',
    '6. 您的权利': '6. 您的權利',
    '您有权：': '您有權：',
    '访问您的个人信息': '存取您的個人資訊。',
    '删除您的账号和相关数据': '刪除您的帳號和相關資料。',
    '撤回您发布的内容': '撤回您發布的內容。',
    '7. 未成年人保护': '7. 未成年人保護',
    '本站不针对 13 岁以下的儿童提供服务。如果您发现有未成年人在未经家长同意的情况下提供了个人信息，请联系我们。': '本站不針對 13 歲以下的兒童提供服務。如果您發現有未成年人在未經家長同意的情況下提供了個人資訊，請聯絡我們。',
    '8. 政策更新': '8. 政策更新',
    '我们可能会不定期更新本隐私政策。更新后的政策将在本页面发布，建议您定期查看。': '我們可能會不定期更新本隱私政策。更新後的政策將在本頁面發布，建議您定期查看。',
    '9. 联系我们': '9. 聯絡我們',
    '如果您对本隐私政策有任何疑问，请通过以下方式联系我们：': '如果您對本隱私政策有任何疑問，請透過以下方式聯絡我們：',
    '网站：guns.yufantechs.com': '網站：guns.yufantechs.com',
    '请在使用本站服务之前仔细阅读以下条款。使用本站即表示您同意受这些条款的约束。': '請在使用本站服務之前仔細閱讀以下條款。使用本站即表示您同意受這些條款的約束。',
    '1. 服务说明': '1. 服務說明',
    '有力气的改枪网站是一个面向《三角洲行动》（Delta Force）玩家的第三方工具网站，提供以下服务：': '有力氣的改槍網站是一個面向《三角洲行動》（Delta Force）玩家的第三方工具網站，提供以下服務：',
    '改枪码分享与浏览': '改槍碼分享與瀏覽。',
    '每日密码查询': '每日密碼查詢。',
    '特勤处制造利润计算': '特勤處製造利潤計算。',
    '物品价格走势查询': '物品價格走勢查詢。',
    '卡战备推荐系统': '卡戰備推薦系統。',
    '玩家社区功能': '玩家社群功能。',
    '2. 免责声明': '2. 免責聲明',
    '本站为非官方第三方工具，与腾讯、Team Jade 或三角洲行动官方无任何关联': '本站為非官方第三方工具，與騰訊、Team Jade 或三角洲行動官方無任何關聯。',
    '本站提供的数据来源于公开 API，仅供参考，不保证实时性和准确性': '本站提供的資料來源於公開 API，僅供參考，不保證即時性和準確性。',
    '因游戏更新导致的数据偏差，本站不承担任何责任': '因遊戲更新導致的資料偏差，本站不承擔任何責任。',
    '使用本站提供的改枪码或其他信息所产生的任何后果，由用户自行承担': '使用本站提供的改槍碼或其他資訊所產生的任何後果，由使用者自行承擔。',
    '3. 用户行为规范': '3. 使用者行為規範',
    '使用本站服务时，您同意：': '使用本站服務時，您同意：',
    '不发布违法、色情、暴力、仇恨或其他不当内容': '不發布違法、色情、暴力、仇恨或其他不當內容。',
    '不冒充他人或虚假宣传': '不冒充他人或虛假宣傳。',
    '不利用本站进行任何商业行为（未经授权）': '不利用本站進行任何商業行為（未經授權）。',
    '不尝试攻击、破坏或干扰本站的正常运行': '不嘗試攻擊、破壞或干擾本站的正常運作。',
    '不批量爬取或自动化访问本站数据': '不批量爬取或自動化存取本站資料。',
    '4. 知识产权': '4. 智慧財產權',
    '《三角洲行动》的商标、图像和游戏数据归腾讯及 Team Jade 所有': '《三角洲行動》的商標、圖像和遊戲資料歸騰訊及 Team Jade 所有。',
    '本站的界面设计和代码归 YufanTechs 所有': '本站的介面設計和程式碼歸 YufanTechs 所有。',
    '用户发布的改枪码内容归发布者所有': '使用者發布的改槍碼內容歸發布者所有。',
    '5. 账号管理': '5. 帳號管理',
    '您有责任保护自己的账号安全': '您有責任保護自己的帳號安全。',
    '我们保留在违反使用条款时封禁或删除账号的权利': '我們保留在違反使用條款時封鎖或刪除帳號的權利。',
    '长期不活跃的账号可能会被清理': '長期不活躍的帳號可能會被清理。',
    '6. 服务变更与终止': '6. 服務變更與終止',
    '我们保留在任何时候修改、暂停或终止本站服务的权利，恕不另行通知。对于服务变更或终止造成的任何损失，本站不承担责任。': '我們保留在任何時候修改、暫停或終止本站服務的權利，恕不另行通知。對於服務變更或終止造成的任何損失，本站不承擔責任。',
    '7. 条款修改': '7. 條款修改',
    '我们可能会不定期修改本使用条款。修改后的条款将在本页面发布并立即生效。继续使用本站即表示您接受修改后的条款。': '我們可能會不定期修改本使用條款。修改後的條款將在本頁面發布並立即生效。繼續使用本站即表示您接受修改後的條款。',
    '1. 什么是 Cookie': '1. 什麼是 Cookie',
    'Cookie 是网站存储在您浏览器中的小型文本文件，用于记录您的偏好和使用信息。': 'Cookie 是網站儲存在您瀏覽器中的小型文字檔案，用於記錄您的偏好和使用資訊。',
    '2. 本站使用的存储方式': '2. 本站使用的儲存方式',
    '本站主要使用浏览器的 LocalStorage（本地存储）来保存以下信息：': '本站主要使用瀏覽器的 LocalStorage（本機儲存）來保存以下資訊：',
    '玩家登录状态': '玩家登入狀態',
    '：记住您的登录信息，避免每次访问都需要重新登录（存储键：df_player）': '：記住您的登入資訊，避免每次造訪都需要重新登入（儲存鍵：df_player）。',
    '3. 本站不使用的技术': '3. 本站不使用的技術',
    '本站不使用第三方 Cookie': '本站不使用第三方 Cookie。',
    '本站不使用广告追踪 Cookie': '本站不使用廣告追蹤 Cookie。',
    '本站不使用任何分析追踪工具（如 Google Analytics）': '本站不使用任何分析追蹤工具（如 Google Analytics）。',
    '本站不进行跨站追踪': '本站不進行跨站追蹤。',
    '4. 第三方 Cookie': '4. 第三方 Cookie',
    '本站嵌入的官方地图工具（iframe）可能会设置来自 df.qq.com 的 Cookie，这些 Cookie 由腾讯控制，不在本站管理范围内。': '本站嵌入的官方地圖工具（iframe）可能會設定來自 df.qq.com 的 Cookie，這些 Cookie 由騰訊控制，不在本站管理範圍內。',
    '5. 如何管理': '5. 如何管理',
    '您可以通过以下方式管理存储数据：': '您可以透過以下方式管理儲存資料：',
    '在玩家社区页面点击"退出"清除登录数据': '在玩家社群頁面點擊「退出」清除登入資料。',
    '在浏览器设置中清除本站的 LocalStorage 数据': '在瀏覽器設定中清除本站的 LocalStorage 資料。',
    '使用浏览器的隐私/无痕模式访问本站': '使用瀏覽器的隱私／無痕模式造訪本站。',
    '如果我们更改了数据存储方式，将更新本 Cookie 政策并在本页面发布。': '如果我們變更了資料儲存方式，將更新本 Cookie 政策並在本頁面發布。',
    // ---- Loadout ----
    '加载战备数据中...': '載入戰備資料中...',
    '暂无战备数据': '暫無戰備資料',
    '头盔': '頭盔', '胸挂': '胸掛', '背包': '背包',
    '推荐配件': '推薦配件',
    '购买成本': '購買成本', '装备价值': '裝備價值', '配件价值': '配件價值', '总估值': '總估值',
    '三角洲行动卡战备配装推荐，不同预算档位的最优枪械、护甲、装备搭配方案。': '三角洲行動卡戰備配裝推薦，不同預算檔位的最優槍械、護甲、裝備搭配方案。',
    '更新：': '更新：',
    '价格基于交易行实时均价，每小时更新 · 含配件推荐': '價格基於交易行即時均價，每小時更新 · 含配件推薦',
    '大坝、长弓机密': '大壩、長弓機密',
    '巴克什、航天机密': '巴克什、航天機密',
    '潮汐监狱-适应': '潮汐監獄-適應',
    '巴克什-绝密': '巴克什-絕密',
    '航天基地-绝密': '航天基地-絕密',
    '潮汐监狱-绝密': '潮汐監獄-絕密',
    '策略方案': '策略方案', '多枪方案': '多槍方案',
    '该档位暂无{type}方案': '該檔位暫無{type}方案',
    '策略': '策略', '多枪': '多槍',
    '说明：': '說明：',
    '：🔫枪械拉满 / ⚖️均衡 / 🦺胸挂拉满 / 🏃轻装跑图（少配件轻装，适合跑图丢包场景）。': '：🔫槍械拉滿 / ⚖️均衡 / 🦺胸掛拉滿 / 🏃輕裝跑圖（少配件輕裝，適合跑圖丟包場景）。',
    '：不同枪械+最优装备组合。': '：不同槍械+最優裝備組合。',
    '配件': '配件',
    '：点击展开查看推荐配件，价值已计入总估值。': '：點擊展開查看推薦配件，價值已計入總估值。',
    '品级：': '品級：',
    // ---- Streamers ----
    '加载主播数据...': '載入主播資料...',
    '返回主播列表': '返回主播列表',
    '{n} 个方案 · {apply} 使用 · 点击展开查看配件': '{n} 個方案 · {apply} 使用 · 點擊展開查看配件',
    '搜索枪名或方案名...': '搜尋槍名或方案名...',
    '{n} 赞': '{n} 讚',
    '配件详情': '配件詳情',
    '配件总价：': '配件總價：',
    '无配件数据': '無配件資料',
    '复制改枪码': '複製改槍碼',
    '三角洲行动主播改枪码合集，热门主播同款武器配置方案，一键复制使用。': '三角洲行動主播改槍碼合集，熱門主播同款武器配置方案，一鍵複製使用。',
    '来自官方社区 · {n} 位主播 · {c} 个方案': '來自官方社群 · {n} 位主播 · {c} 個方案',
    '搜索主播名称...': '搜尋主播名稱...',
    '没有找到「{q}」相关的主播': '沒有找到「{q}」相關的主播',
    '{n} 个方案': '{n} 個方案',
    '{n} 使用': '{n} 使用',
    // ---- Gun landing pages ----
    '武器改枪码大全': '武器改槍碼大全',
    '武器改枪码': '武器改槍碼',
    '三角洲行动武器改枪码': '三角洲行動武器改槍碼',
    '三角洲行动各热门武器的改枪码大全，按武器查询官方与主播同款改枪码，一键复制。': '三角洲行動各熱門武器的改槍碼大全，按武器查詢官方與主播同款改槍碼，一鍵複製。',
    '按武器查询三角洲行动改枪码 · 共 {n} 把武器': '按武器查詢三角洲行動改槍碼 · 共 {n} 把武器',
    '「{model}」改枪码大全': '「{model}」改槍碼大全',
    '「{model}」改枪码': '「{model}」改槍碼',
    '「{model}」三角洲改枪码大全，收录该武器的官方与主播同款改枪码，一键复制导入游戏。': '「{model}」三角洲改槍碼大全，收錄該武器的官方與主播同款改槍碼，一鍵複製匯入遊戲。',
    // ---- OfficialCodes ----
    '加载官方改枪码...': '載入官方改槍碼...',
    '三角洲行动官方社区热门改枪码，按使用量排行，含完整配件列表和价格。': '三角洲行動官方社群熱門改槍碼，按使用量排行，含完整配件列表和價格。',
    '来自官方社区 · {c} 个方案 · 点击展开查看配件 · 同步：{time}': '來自官方社群 · {c} 個方案 · 點擊展開查看配件 · 同步：{time}',
    '搜索枪名、方案名、作者...': '搜尋槍名、方案名、作者...',
    '使用量 高→低': '使用量 高→低',
    '点赞 高→低': '按讚 高→低',
    '配件列表': '配件列表',
    '此方案无配件数据': '此方案無配件資料',
    '点击卡片展开查看配件详情。点击改枪码直接复制。数据每6小时自动同步。': '點擊卡片展開查看配件詳情。點擊改槍碼直接複製。資料每6小時自動同步。',
    // ---- PriceTrend ----
    '需要至少2天数据才能显示走势图': '需要至少2天資料才能顯示走勢圖',
    '系统每天自动记录价格，过几天就有图了': '系統每天自動記錄價格，過幾天就有圖了',
    '加载价格数据中...': '載入價格資料中...',
    '三角洲行动物品价格走势图，实时追踪枪械、护甲、配件等物品的历史价格变化。': '三角洲行動物品價格走勢圖，即時追蹤槍械、護甲、配件等物品的歷史價格變化。',
    '更新日期：': '更新日期：',
    '共 {n} 个物品': '共 {n} 個物品',
    '搜索物品名称...': '搜尋物品名稱...',
    '暂无价格数据': '暫無價格資料',
    '请管理员在后台获取价格数据': '請管理員在後台取得價格資料',
    '价格为交易行均价，每天自动更新。点击物品可查看历史走势图。涨跌幅对比前一天数据。数据积累越多，走势图越完整。': '價格為交易行均價，每天自動更新。點擊物品可查看歷史走勢圖。漲跌幅對比前一天資料。資料累積越多，走勢圖越完整。',
    // ---- Manufacturing ----
    '加载制造数据中...': '載入製造資料中...',
    '暂无制造数据': '暫無製造資料',
    '请管理员在后台获取数据': '請管理員在後台取得資料',
    '三角洲行动特勤处制造利润计算器，实时制造成本与收益分析，找到最赚钱的制造方案。': '三角洲行動特勤處製造利潤計算器，即時製造成本與收益分析，找到最賺錢的製造方案。',
    '共 {n} 个制造方案': '共 {n} 個製造方案',
    '各部门最赚推荐': '各部門最賺推薦',
    '技术中心': '技術中心', '工作台': '工作台', '制药台': '製藥台', '防具台': '防具台',
    '净利润': '淨利潤',
    '每小时 {a} · 售价 {b}': '每小時 {a} · 售價 {b}',
    '总利润 高→低': '總利潤 高→低',
    '利润/小时 高→低': '利潤/小時 高→低',
    '售价 高→低': '售價 高→低',
    '耗时 短→长': '耗時 短→長',
    '售价': '售價', '成本': '成本', '每小时': '每小時', '总利润': '總利潤',
    '总利润 = 售价 - 材料成本 - 手续费。品级颜色：': '總利潤 = 售價 - 材料成本 - 手續費。品級顏色：',
    // ---- Community ----
    '包含违规内容「{w}」': '包含違規內容「{w}」',
    '不允许包含手机号': '不允許包含手機號',
    '不允许包含邮箱地址': '不允許包含電子郵件地址',
    '不允许包含网址链接': '不允許包含網址連結',
    '不允许包含联系方式': '不允許包含聯絡方式',
    '用户名{msg}': '使用者名稱{msg}',
    '昵称{msg}': '暱稱{msg}',
    '简介{msg}': '簡介{msg}',
    '请先同意用户协议': '請先同意使用者協議',
    '用户名和密码必填': '使用者名稱和密碼必填',
    '密码至少6位': '密碼至少6位',
    '两次密码不一致': '兩次密碼不一致',
    '用户名已存在': '使用者名稱已存在',
    '注册失败': '註冊失敗',
    '注册成功！': '註冊成功！',
    '欢迎，{name}！': '歡迎，{name}！',
    '用户名或密码错误': '使用者名稱或密碼錯誤',
    '登录尝试过多，请 {n} 分钟后再试': '登入嘗試過多，請 {n} 分鐘後再試。',
    '已退出': '已登出',
    '头像上传失败': '頭像上傳失敗',
    '上传失败': '上傳失敗',
    '提交失败': '提交失敗',
    '资料已提交，等待管理员审核': '資料已提交，等待管理員審核',
    '已有此枪械': '已有此槍械',
    '{name} 已添加！': '{name} 已新增！',
    '删除 {name}？其下所有改装码也会被删除！': '刪除 {name}？其下所有改裝碼也會被刪除！',
    '已删除': '已刪除',
    '请填写改枪码': '請填寫改槍碼',
    '已提交，等待管理员审核': '已提交，等待管理員審核',
    '确定删除？': '確定刪除？',
    '更新成功！': '更新成功！',
    '加载社区数据...': '載入社群資料...',
    '加载枪械数据中...': '載入槍械資料中...',
    '返回社区': '返回社群',
    '{name} 的改枪码': '{name} 的改槍碼',
    '点击改枪码即可复制 · {g} 把武器 · {v} 个配置': '點擊改槍碼即可複製 · {g} 把武器 · {v} 個配置',
    '添加枪械与改枪码': '新增槍械與改槍碼',
    '搜索枪械（从官方目录添加）': '搜尋槍械（從官方目錄新增）',
    '输入枪名，如 AKM、M4A1...': '輸入槍名，如 AKM、M4A1...',
    '添加': '新增',
    '选择枪械添加改枪码': '選擇槍械新增改槍碼',
    '-- 选择枪械 --': '-- 選擇槍械 --',
    '({n}个配置)': '（{n}個配置）',
    '段位': '段位',
    '不选': '不選',
    '价格': '價格',
    '类型': '類型',
    '满改': '滿改',
    '52米': '52米',
    '射程': '射程',
    '改枪码 *': '改槍碼 *',
    '粘贴改枪码': '貼上改槍碼',
    '添加改枪码': '新增改槍碼',
    '全部段位': '全部段位',
    '默认排序': '預設排序',
    '还没有枪械，使用上方搜索框添加': '還沒有槍械，使用上方搜尋框新增',
    '没有找到匹配的枪械': '沒有找到符合的槍械',
    '{n} 个配置方案': '{n} 個配置方案',
    '删除枪械': '刪除槍械',
    '改装类型': '改裝類型',
    '改枪码': '改槍碼',
    '有效射程': '有效射程',
    '操作': '操作',
    '存': '存', '消': '消', '编': '編', '删': '刪',
    '待审核': '待審核',
    '三角洲行动玩家改枪码分享社区，注册分享你的武器配置方案，交流改枪心得。': '三角洲行動玩家改槍碼分享社群，註冊分享你的武器配置方案，交流改槍心得。',
    '退出': '登出',
    '登录': '登入',
    '注册': '註冊',
    '分享和发现玩家的改枪方案 · 点击作者查看改枪码': '分享和發現玩家的改槍方案 · 點擊作者查看改槍碼',
    '搜索玩家...': '搜尋玩家...',
    '我的改枪码': '我的改槍碼',
    '还没有人分享改枪码': '還沒有人分享改槍碼',
    '点击上方按钮开始添加！': '點擊上方按鈕開始新增！',
    '登录后即可创建改枪方案': '登入後即可建立改槍方案',
    '我': '我',
    '{n} 把武器': '{n} 把武器',
    '{n} 个配置': '{n} 個配置',
    '用户名': '使用者名稱',
    '密码': '密碼',
    '（至少6位）': '（至少6位）',
    '确认密码': '確認密碼',
    '再次输入密码': '再次輸入密碼',
    '密码一致': '密碼一致',
    '昵称（选填）': '暱稱（選填）',
    '昵称': '暱稱',
    '我已阅读并同意': '我已閱讀並同意',
    '《用户协议》': '《使用者協議》',
    '和': '和',
    '《隐私政策》': '《隱私政策》',
    '个人资料': '個人資料',
    '你有一份资料修改正在审核中，审核通过后自动生效': '你有一份資料修改正在審核中，審核通過後自動生效',
    '显示名称': '顯示名稱',
    '个人简介': '個人簡介',
    '一句话介绍自己': '一句話介紹自己',
    '保存中...': '儲存中...',
    '保存': '儲存',
    '取消': '取消',
  },
};
